var _path, _polygon, _path2, _path3, _path4, _path5, _path6, _polygon2, _path7, _polygon3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon4, _path15, _path16, _path17, _rect, _rect2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParalympicwinnerspodiumPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.454,11.6024c-23.02871-1.3183-44.91261,13.5192-53.34841,32.6556s-4.8904,41.3151,5.5311,59.6585c-12.9555-6.2308-31.3935,.2287-36.1155,12.6527-27.0487-25.2666-70.318-35.6743-107.9641-25.9691-37.646,9.7053-67.9912,39.0911-75.716,73.3224-23.02909-11.5362-52.2833-12.6026-76.2934-2.7811-3.7684-24.8968-36.4703-42.7028-63.0573-34.3343,11.3923-18.9352,6.738-43.7451-8.7485-60.2127-15.4866-16.4677-40.2136-24.8362-64.326-24.6037-24.1123,.2325-47.5362,8.3967-67.576,20.3458l-21.86056-1.1967c29.21926,51.044,81.55256,90.086,140.83056,112.3112,59.278,22.2251,125.1121,28.4215,189.2165,23.808,102.9641-7.4103,212.22839-28.0655,271.34309-103.5395,5.3737-6.8608,6.1989-32.1894,7.806-40.4321,3.9494-20.2561-16.6929-40.3668-39.72148-41.685Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8479,325.9202s258.8579-.363,375.31099-.0145c18.2239,.0545,39.4454-.2974,62.163-.2069,123.0498,.4902,291.80069,.2214,291.80069,.2214v-23.1845s-181.7647-4.624-354.34529-5.211c-172.4447-.5865-374.92939-.7543-374.92939-.7543v29.1498Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.41258,12.5285s10.83284,175.0781,310.16781,177.6512c300.42629,2.5825,310.01229-178.6588,310.01229-178.6588h48.3145v55.1484s-106.541,135.0895-342.15529,144.0955C160.1376,219.7707,9.832,58.9499,9.832,58.9499V10.5132l59.58058,2.0153Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.90718,117.4921c-.5528,.1918-160.2261,127.2322-358.32679,120.9405C118.7481,230.1486,10.8479,114.7958,10.8479,114.7958l.1079,18.4918s106.3411,102.2154,367.17329,110.4994c198.10069,6.2917,359.22529-102.0873,359.77809-102.2791",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.02438,211.1294c-.5528,.1609-161.2149,56.1251-359.31559,50.8448C119.8765,255.0217,10.8479,208.525,10.8479,208.525v16.6477s109.0286,37.3076,369.86089,44.26c198.10069,5.2804,358.76279-37.9871,359.31559-38.148",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.16059,247.2804c-1.4068,.6896-15.5949,59.7214-15.2481,59.7584,.3468,.0369,19.4463,2.1479,19.4463,2.1479,0,0,27.6904-65.2777,26.9768-65.136-.71358,.1418-31.175,3.2297-31.175,3.2297Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.60739,264.5867c-1.7111,3.7234-9.526,36.1027-8.10839,36.1632,1.41749,.0606,11.62519,0,11.62519,0,0,0,16.529-35.7593,15.1223-36.1632s-18.6391,0-18.6391,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.837,212.6504s-11.88711,37.042-12.23011,37.0936,12.23011-1.8983,12.23011-1.8983l17.081-40.9739-17.081,5.7786Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.12769,170.9964c-.5818-1.0024,13.3138-46.9601,13.3138-46.9601,0,0,29.2129-22.0863,28.6103-21.5902s-23.86678,62.2016-25.2736,62.2016c-1.4067,0-16.6505,6.3487-16.6505,6.3487Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.43309,193.3838c-.7296,2.2329-10.6033,34.9246-10.6033,34.9246l8.3994-3.1813,18.3812-34.3038-16.1773,2.5605Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2132,245.3542c1.4067,.6683,16.5597,59.6989,16.2129,59.7347-.3468,.0359-19.4463,2.0815-19.4463,2.0815,0,0-29.2973-66.8033-28.58371-66.666,.7136,.1374,31.81711,4.8498,31.81711,4.8498Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1477,262.5229c1.7112,3.0801,13.0967,35.2334,11.6792,35.2835-1.4176,.05-12.643,.5186-12.643,.5186,0,0-19.3297-36.2531-17.923-36.5872,1.4068-.3342,18.8868,.7851,18.8868,.7851Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5016,212.6504s11.887,37.042,12.2301,37.0936c.343,.0516-12.2301-1.8983-12.2301-1.8983l-17.081-40.9739,17.081,5.7786Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5846,180.7714c.5818-1.1289-15.5226-61.3927-15.5226-61.3927,0,0-32.7205-26.2091-32.1178-25.6504,.6026,.5588,22.11228,72.5888,23.519,72.5888s24.1214,14.4543,24.1214,14.4543Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9055,193.3838c.7296,2.2329,10.6033,34.9246,10.6033,34.9246l-8.3148-3.0233-18.3812-39.5094,16.0927,7.6081Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.55028,
    cy: 206.31173,
    rx: 4.65472,
    ry: 8.61638,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.8186,
    cy: 254.821,
    rx: 4.6547,
    ry: 8.6164,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3814,206.5277c0,4.7587-2.084,8.6164-4.6547,8.6164s-4.6548-3.8577-4.6548-8.6164,2.084-8.6164,4.6548-8.6164,4.6547,3.8577,4.6547,8.6164Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.4386,
    cy: 110.20953,
    rx: 4.6547,
    ry: 8.61638,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.0263,181.5751c0,4.7587-2.084,8.6164-4.6547,8.6164s-4.6548-3.8577-4.6548-8.6164,2.084-8.6163,4.6548-8.6163,4.6547,3.8577,4.6547,8.6163Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.461,231.1538c0,3.1983-1.4006,5.791-3.1284,5.791s-3.1284-2.5927-3.1284-5.791,1.4006-5.7909,3.1284-5.7909,3.1284,2.5927,3.1284,5.7909Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.6567,
    cy: 190.8233,
    rx: 3.1284,
    ry: 5.791,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.533,
    cy: 183.23,
    rx: 3.1284,
    ry: 5.791,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7632,202.5669c0,3.1983-1.4006,5.791-3.1284,5.791s-3.1284-2.5927-3.1284-5.791,1.4006-5.7909,3.1284-5.7909,3.1284,2.5927,3.1284,5.7909Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0073,260.7978c0,3.1983-1.4006,5.791-3.1283,5.791-1.7278,0-3.1284-2.5927-3.1284-5.791s1.4006-5.791,3.1284-5.791c1.7277,0,3.1283,2.5927,3.1283,5.791Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0928,288.067c0,3.1982-1.4007,5.7909-3.1284,5.7909-1.7278,0-3.1284-2.5927-3.1284-5.7909s1.4006-5.791,3.1284-5.791c1.7277,0,3.1284,2.5927,3.1284,5.791Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8674,276.698c0,3.2376-1.4178,5.8622-3.1669,5.8622-1.749,0-3.1668-2.6246-3.1668-5.8622s1.4178-5.8622,3.1668-5.8622c1.7491,0,3.1669,2.6246,3.1669,5.8622Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.6924,
    cy: 277.4484,
    rx: 3.1669,
    ry: 5.8622,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.6105,
    cy: 282.5602,
    rx: 3.1669,
    ry: 5.8622,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.624,
    cy: 286.9409,
    rx: 2.5201,
    ry: 4.6649,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4688,123.9987c0,2.5763-1.1282,4.6649-2.52,4.6649s-2.5201-2.0886-2.5201-4.6649,1.1283-4.6649,2.5201-4.6649,2.52,2.0886,2.52,4.6649Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.9929,
    cy: 274.9394,
    rx: 1.9247,
    ry: 3.5628,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6664,239.3487c0,2.9943-.9282,5.4216-2.0731,5.4216-1.145,0-2.0731-2.4273-2.0731-5.4216s.9281-5.4217,2.0731-5.4217c1.1449,0,2.0731,2.4274,2.0731,5.4217Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.1835,
    cy: 244.4176,
    rx: 3.1516,
    ry: 5.8197,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.74919,220.9322c0,3.2141-1.4111,5.8196-3.1517,5.8196-1.74049,0-3.1516-2.6055-3.1516-5.8196s1.41111-5.8197,3.1516-5.8197c1.7406,0,3.1517,2.6055,3.1517,5.8197Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.6024,
    cy: 278.5022,
    rx: 3.1516,
    ry: 5.8197,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4674,236.9448c0,2.1934-.8314,3.9715-1.8569,3.9715s-1.8568-1.7781-1.8568-3.9715,.8313-3.9715,1.8568-3.9715,1.8569,1.7781,1.8569,3.9715Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3905,174.9679c0,2.1934-.8313,3.9714-1.8568,3.9714-1.0256,0-1.8569-1.778-1.8569-3.9714s.8313-3.9715,1.8569-3.9715c1.0255,0,1.8568,1.7781,1.8568,3.9715Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.95889,246.2993c0,2.1934-.8313,3.9715-1.8568,3.9715s-1.8569-1.7781-1.8569-3.9715,.8314-3.9714,1.8569-3.9714,1.8568,1.778,1.8568,3.9714Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.04479,282.276c0,2.1934-.8313,3.9715-1.8569,3.9715-1.0255,0-1.8568-1.7781-1.8568-3.9715s.8313-3.9715,1.8568-3.9715c1.0256,0,1.8569,1.7781,1.8569,3.9715Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.50819,254.5613c0,2.1934-.8313,3.9715-1.8568,3.9715s-1.8569-1.7781-1.8569-3.9715,.8314-3.9715,1.8569-3.9715,1.8568,1.7781,1.8568,3.9715Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.21919,223.5122c0,2.1933-.8314,3.9714-1.8569,3.9714s-1.8568-1.7781-1.8568-3.9714,.8313-3.9715,1.8568-3.9715,1.8569,1.7781,1.8569,3.9715Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.97819,247.5206c0,1.5189-.5757,2.7502-1.2859,2.7502-.7101,0-1.2858-1.2313-1.2858-2.7502,0-1.519,.5757-2.7503,1.2858-2.7503,.7102,0,1.2859,1.2313,1.2859,2.7503Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53109,218.1819c0,1.5189-.5757,2.7503-1.2859,2.7503-.7101,0-1.2859-1.2314-1.2859-2.7503s.5758-2.7502,1.2859-2.7502c.7102,0,1.2859,1.2313,1.2859,2.7502Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 354.77079,
    cy: 229.9531,
    rx: 1.2859,
    ry: 2.7502,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.74929,248.9499c0,1.033-.3916,1.8705-.8746,1.8705-.4829,0-.8745-.8375-.8745-1.8705s.3916-1.8705,.8745-1.8705c.483,0,.8746,.8375,.8746,1.8705Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.00019,284.3219c0,1.033-.3915,1.8705-.8745,1.8705s-.8746-.8375-.8746-1.8705c0-1.0331,.3916-1.8705,.8746-1.8705s.8745,.8374,.8745,1.8705Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35929,250.8204c0,1.033-.3915,1.8704-.8745,1.8704s-.8746-.8374-.8746-1.8704c0-1.0331,.3916-1.8705,.8746-1.8705s.8745,.8374,.8745,1.8705Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.35801 275.1912 75.62427 280.2825 79.76797 283.0671 75.62427 285.8517 73.35801 290.943 71.09175 285.8517 66.9481 283.0671 71.09175 280.2825 73.35801 275.1912",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.5782 215.6362 125.7114 218.1819 127.7832 219.5742 125.7114 220.9665 124.5782 223.5122 123.4451 220.9665 121.3733 219.5742 123.4451 218.1819 124.5782 215.6362",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.983 210.306 287.11609 212.8517 289.18789 214.244 287.11609 215.6362 285.983 218.1819 284.84979 215.6362 282.778 214.244 284.84979 212.8517 285.983 210.306",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.8028 177.8998 55.9359 180.4454 58.0078 181.8377 55.9359 183.23 54.8028 185.7757 53.6697 183.23 51.5978 181.8377 53.6697 180.4454 54.8028 177.8998",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.0526 242.3614 246.1858 244.907 248.2576 246.2993 246.1858 247.6916 245.0526 250.2373 243.9195 247.6916 241.8476 246.2993 243.9195 244.907 245.0526 242.3614",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.02418,
    cy: 208.78118,
    rx: 4.6547,
    ry: 8.61633,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.10108,257.2905c0,4.7586,2.084,8.6163,4.6547,8.6163s4.6548-3.8577,4.6548-8.6163-2.084-8.6164-4.6548-8.6164-4.6547,3.8577-4.6547,8.6164Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.84779,
    cy: 208.99713,
    rx: 4.6547,
    ry: 8.61638,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.13588,
    cy: 112.67898,
    rx: 4.6547,
    ry: 8.61633,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 604.20289,
    cy: 184.0446,
    rx: 4.6547,
    ry: 8.6164,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.24189,
    cy: 233.6233,
    rx: 3.1284,
    ry: 5.791,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.78938,193.2928c0,3.1982,1.40062,5.7909,3.1284,5.7909s3.1284-2.5927,3.1284-5.7909-1.4006-5.791-3.1284-5.791-3.1284,2.5927-3.1284,5.791Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.91309,185.6995c0,3.1982,1.4006,5.7909,3.1284,5.7909s3.1284-2.5927,3.1284-5.7909-1.4006-5.791-3.1284-5.791-3.1284,2.5927-3.1284,5.791Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.93969,
    cy: 205.0364,
    rx: 3.1284,
    ry: 5.791,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.56708,263.2672c0,3.1983,1.4007,5.791,3.1284,5.791,1.7278,0,3.1284-2.5927,3.1284-5.791s-1.4006-5.7909-3.1284-5.7909c-1.7277,0-3.1284,2.5927-3.1284,5.7909Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 716.61008,
    cy: 290.5364,
    rx: 3.1284,
    ry: 5.791,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 626.87389,
    cy: 279.1674,
    rx: 3.1669,
    ry: 5.8622,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.71519,279.9179c0,3.2376,1.4179,5.8622,3.1669,5.8622s3.16691-2.6246,3.16691-5.8622-1.41791-5.8623-3.16691-5.8623-3.1669,2.6246-3.1669,5.8623Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.79709,285.0296c0,3.2377,1.4178,5.8623,3.1668,5.8623,1.74911,0,3.1669-2.6246,3.1669-5.8623s-1.41779-5.8622-3.1669-5.8622c-1.749,0-3.1668,2.6246-3.1668,5.8622Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.43039,289.4103c0,2.5764,1.1283,4.6649,2.5201,4.6649s2.52-2.0885,2.52-4.6649-1.1282-4.6649-2.52-4.6649-2.5201,2.0886-2.5201,4.6649Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.10558,126.4682c0,2.5763,1.1283,4.6648,2.5201,4.6648s2.5201-2.0885,2.5201-4.6648-1.1283-4.6649-2.5201-4.6649-2.5201,2.0885-2.5201,4.6649Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.65689,277.4089c0,1.9676,.8617,3.5627,1.9247,3.5627s1.9247-1.5951,1.9247-3.5627c0-1.9677-.8617-3.5628-1.9247-3.5628s-1.9247,1.5951-1.9247,3.5628Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 544.98119,
    cy: 241.8181,
    rx: 2.0731,
    ry: 5.4217,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.23929,246.8871c0,3.2141,1.4111,5.8196,3.15171,5.8196,1.74049,0,3.15159-2.6055,3.15159-5.8196s-1.4111-5.8197-3.15159-5.8197c-1.74061,0-3.15171,2.6055-3.15171,5.8197Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 401.71339,
    cy: 227.8323,
    rx: 3.15161,
    ry: 5.8197,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.23009,283.6316c0,2.4654,1.0824,4.4641,2.4175,4.4641,1.3352,0,2.4175-1.9987,2.4175-4.4641s-1.0823-4.4642-2.4175-4.4642c-1.3351,0-2.4175,1.9987-2.4175,4.4642Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.10709,239.4143c0,2.1933,.8313,3.9714,1.8568,3.9714,1.0256,0,1.8569-1.7781,1.8569-3.9714s-.8313-3.9715-1.8569-3.9715c-1.0255,0-1.8568,1.7781-1.8568,3.9715Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.18389,177.4373c0,2.1934,.8314,3.9715,1.8569,3.9715s1.8569-1.7781,1.8569-3.9715-.8314-3.9714-1.8569-3.9714-1.8569,1.778-1.8569,3.9714Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.61549,248.7688c0,2.1934,.8314,3.9714,1.8569,3.9714s1.8568-1.778,1.8568-3.9714-.8313-3.9715-1.8568-3.9715-1.8569,1.7781-1.8569,3.9715Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.52969,284.7454c0,2.1934,.83131,3.9715,1.8568,3.9715s1.8569-1.7781,1.8569-3.9715-.83139-3.9714-1.8569-3.9714-1.8568,1.7781-1.8568,3.9714Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.22619,279.1674c0,2.1934,.8313,3.9715,1.8569,3.9715,1.0255,0,1.8568-1.7781,1.8568-3.9715s-.8313-3.9714-1.8568-3.9714c-1.0256,0-1.8569,1.778-1.8569,3.9714Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.06619,257.0308c0,2.1933,.8314,3.9714,1.8569,3.9714s1.8568-1.7781,1.8568-3.9714-.8313-3.9715-1.8568-3.9715-1.8569,1.7781-1.8569,3.9715Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35529,225.9816c0,2.1934,.8313,3.9715,1.8568,3.9715,1.0256,0,1.85691-1.7781,1.85691-3.9715s-.83131-3.9714-1.85691-3.9714c-1.0255,0-1.8568,1.778-1.8568,3.9714Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.59629,249.99c0,1.5189,.57571,2.7502,1.2858,2.7502,.7102,0,1.28591-1.2313,1.28591-2.7502s-.57571-2.7502-1.28591-2.7502c-.71009,0-1.2858,1.2313-1.2858,2.7502Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.04339,220.6514c0,1.5189,.5757,2.7502,1.2858,2.7502,.7102,0,1.2859-1.2313,1.2859-2.7502s-.5757-2.7503-1.2859-2.7503c-.7101,0-1.2858,1.2314-1.2858,2.7503Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.82519,251.4194c0,1.033,.3915,1.8704,.8745,1.8704s.8746-.8374,.8746-1.8704c0-1.0331-.3916-1.8705-.8746-1.8705s-.8745,.8374-.8745,1.8705Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.57429,286.7913c0,1.0331,.3915,1.8705,.8745,1.8705s.8745-.8374,.8745-1.8705c0-1.033-.3915-1.8704-.8745-1.8704s-.8745,.8374-.8745,1.8704Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.59769,
    cy: 283.1389,
    rx: 0.8745,
    ry: 1.8705,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.21509,253.2898c0,1.0331,.3916,1.8705,.8746,1.8705s.8745-.8374,.8745-1.8705c0-1.033-.3915-1.8704-.8745-1.8704s-.8746,.8374-.8746,1.8704Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "686.21648 277.6606 683.95018 282.752 679.80648 285.5366 683.95018 288.3211 686.21648 293.4125 688.48268 288.3211 692.62638 285.5366 688.48268 282.752 686.21648 277.6606",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "634.99619 218.1057 633.86309 220.6514 631.79119 222.0437 633.86309 223.4359 634.99619 225.9816 636.12929 223.4359 638.20119 222.0437 636.12929 220.6514 634.99619 218.1057",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.59149 212.7754 472.45839 215.3211 470.38649 216.7134 472.45839 218.1057 473.59149 220.6514 474.72459 218.1057 476.79649 216.7134 474.72459 215.3211 473.59149 212.7754",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "704.77168 180.3692 703.63848 182.9149 701.56668 184.3072 703.63848 185.6995 704.77168 188.2451 705.90478 185.6995 707.97658 184.3072 705.90478 182.9149 704.77168 180.3692",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "514.52179 244.8308 513.38869 247.3765 511.31689 248.7688 513.38869 250.1611 514.52179 252.7067 515.655 250.1611 517.72679 248.7688 515.655 247.3765 514.52179 244.8308",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.46319,241.9733s6.1069,23.7283,7.54881,23.772h9.57759l3.0021-24.5187-20.1285,.7467Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.57358,325.9202c0,.1438-159.1802,.2604-355.49329,.2604-196.3814,0-355.52749-.1166-355.52749-.2604s159.1461-.2604,355.52749-.2604c196.3131,0,355.49329,.1166,355.49329,.2604Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_3--inject-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M510.61579,207.9411c-.5077,0-6.0032-.7611-9.3877,9.3925-3.3846,10.1536-3.0707,14.9124-3.2919,21.9854-.255,8.1523-.5201,11.7749-.5201,11.9442,0,.1692-2.0307,25.7224-1.0153,40.9529l10.66121,1.523s1.01539-10.1536,2.70769-20.3072c1.6922-10.1536,.8461-20.3072,.8461-20.8149v-44.6759Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M556.85369,367.9832c-.53769,.6134,1.6131,9.355,4.83931,14.1091,3.22619,4.7542,5.91469,3.0673,7.16929,8.7416,1.25471,5.6743,1.6131,35.1195,0,37.5733-1.6131,2.4537-3.5847,4.9075-1.9715,5.3676,1.6131,.46,7.3485,1.6869,10.037-1.3803s3.22621-11.8087,3.047-15.7961c-.1792-3.9874,1.0754-24.8444-1.4339-28.3716-2.5092-3.5273-7.1693-6.5945-8.7824-9.9685-1.6131-3.3739-3.2349-16.4019-4.1224-17.1763s-8.7824,6.9012-8.7824,6.9012Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569.929,409.6564l10.104,8.1299v-7.05s-10.09461-8.2622-10.104-8.0346c-.00931,.2275,0,6.9547,0,6.9547Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "569.94059 411.5545 569.92489 414.3997 579.81689 422.3315 579.97689 419.716 569.94059 411.5545"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M576.46359,393.122c-.0962,.1181-2.30159-1.567-5.1754-3.4082-2.8688-1.8511-5.3168-3.1578-5.24919-3.2943,.05649-.1229,2.63159,.986,5.53079,2.8563,2.9039,1.8608,4.9821,3.7437,4.8938,3.8462Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.41179,368.4202c.0179-.0025,.07,.2401,.1556,.7039,.0904,.5151,.2089,1.1898,.35661,2.0309,.31819,1.7593,.70989,4.3287,1.41659,7.4365,.21741,1.6068,1.5033,2.849,2.7752,4.2169,1.2994,1.3584,2.798,2.6718,4.3044,4.2048,.6571,.8393,1.4571,1.5565,2.1414,2.4746,.67541,.9034,1.2681,1.9508,1.47141,3.1449,.27269,2.3564,.21179,4.7162,.23689,7.1698-.0113,4.8911-.1188,9.5462-.23489,13.7796-.04271,2.1264-.17731,4.1145-.09481,5.9995,.0264,1.8868-.03919,3.6581-.2901,5.2557-.4689,3.2163-1.8387,5.5968-3.0819,6.898-.6156,.6645-1.1861,1.0853-1.5874,1.3364-.1951,.1351-.3617,.2098-.4673,.269-.1079,.0556-.1651,.0802-.16949,.0723-.04291-.0568,.89729-.4756,2.07359-1.8132,1.1713-1.3175,2.4542-3.6584,2.8683-6.8169,.4749-3.1358,.0369-6.9857,.2694-11.2127,.08971-4.2317,.1826-8.8856,.1938-13.7682-.0218-2.4265,.03191-4.8533-.2174-7.0747-.1776-1.0849-.7275-2.0785-1.36769-2.9406-.63621-.867-1.45551-1.6179-2.09891-2.4509-1.4514-1.4953-2.97-2.8521-4.2607-4.2282-.6503-.687-1.2648-1.3668-1.7938-2.0827-.259-.3624-.5149-.7187-.6815-1.1415-.1677-.4103-.25-.8151-.3469-1.2072-.6671-3.1479-1.0007-5.7163-1.2585-7.4902-.10769-.8476-.1941-1.5275-.2601-2.0467-.0522-.4688-.0695-.7165-.0518-.7191Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 426.15249,
    y: 366.74752,
    width: 130.39285,
    height: 2.14625,
    transform: "translate(70.01573 814.13235) rotate(-83.46732)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.00859,432.7171s.0148-.2396,.0597-.687c.0485-.4626,.1175-1.1199,.2073-1.9763,.1909-1.7462,.469-4.2897,.8268-7.5619,.7317-6.5647,1.7877-16.0395,3.0932-27.7524,2.64941-23.409,6.3108-55.7594,10.3673-91.6008l.229,.2881c-.6708-.0767-1.3975-.1597-2.1257-.2429l-.0063-.0007,.2882-.2291c-7.4883,65.4884-13.79209,119.7853-15.0302,129.5235l-.03689-.0465c.75479,.098,1.27839,.1659,1.63129,.2117,.3409,.0464,.4963,.0743,.4963,.0743,0,0-.1372-.0056-.4758-.0369-.3594-.0358-.8927-.0889-1.6614-.1655l-.04139-.0041,.00429-.0426c.9922-9.7663,7.1081-64.0847,14.5964-129.573l.0296-.2588,.2588,.0296,.0063,.0007c.7281,.0832,1.4548,.1663,2.1257,.243l.259,.0296-.0299,.2587c-4.1475,35.9079-7.891,68.3182-10.5998,91.7706-1.3693,11.6795-2.4769,21.1273-3.24439,27.6734-.38711,3.2422-.688,5.7623-.89461,7.4924-.1041,.8394-.1839,1.4836-.2401,1.937-.0559,.434-.0927,.6459-.0927,.6459Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M483.15229,429.2826s-2.2801,4.8083-1.9631,5.0986,5.4523,0,5.4523,0c0,0-1.0766-4.5747-1.2668-4.8274l-2.2224-.2712Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M550.01949,173.0035c1.7174,.2422,3.5308-.8454,4.126-2.4746,.179-.4905,.2546-1.0389,.0884-1.534-.1661-.4948-.6141-.9155-1.1358-.9384,.6964-.4785,1.2231-1.2258,1.353-2.0604,.1298-.835-.1702-1.7439-.8275-2.2747-.6572-.531-1.6629-.6188-2.3612-.1434,.01661-.9125-.5416-1.8107-1.3671-2.1998l-3.7188,.8578,3.843,10.7675Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.40849,205.4207l.0202-4.4624s7.7785-1.2735,7.8122-9.0607c.016-3.761-.5807-11.5082-1.2022-18.5136-.668-7.5319-7.0086-13.2865-14.56969-13.2258l-.75131,.006c-8.0971,.5382-12.1638,7.7157-11.40169,15.7953l2.456,30.2283,10.13509,8.2926,7.5014-9.0597Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.42869,200.9583s-4.9052,.452-10.171-2.0762c0,0,2.3981,4.8279,10.1621,4.0643l.0089-1.9881Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.28519,180.9701c.0256,.587-.4506,1.0927-1.06319,1.1304-.61151,.0376-1.12881-.4064-1.15421-.9933-.0253-.587,.4504-1.0933,1.0619-1.1313,.6126-.0378,1.1301,.4072,1.1555,.9942Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.39549,177.2072c-.1367,.146-.9839-.4707-2.1807-.458-1.1954-.0045-2.0686,.6183-2.1994,.4729-.06439-.0644,.0739-.3273,.454-.6087,.3741-.2804,1.0139-.5551,1.75961-.558,.74509-.0018,1.37439,.2675,1.737,.5456,.37029,.2794,.49689,.5407,.42949,.6062Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.44229,187.8699c.1896-.0638,.6429,.881,1.7026,1.4375,1.0502,.5709,2.1144,.4367,2.1605,.6268,.0263,.0872-.2203,.2531-.6883,.3206-.4624,.0693-1.1559,.0077-1.8138-.3434-.6568-.3518-1.0831-.8874-1.2705-1.3042-.1934-.4216-.1809-.7116-.0905-.7373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.06879,180.97c.0255,.5871-.4506,1.0925-1.0631,1.1304-.6115,.0379-1.1289-.4062-1.1543-.9935-.02539-.5868,.4509-1.093,1.0623-1.1309,.6125-.0381,1.1298,.407,1.1551,.994Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.63569,177.5246c-.137,.1461-.9855-.4702-2.1814-.4576-1.195-.0045-2.0684,.6182-2.1994,.4727-.0642-.0642,.0728-.3272,.4545-.6085,.3741-.2806,1.0138-.555,1.7592-.558,.7452-.002,1.3745,.2674,1.73741,.5452,.36909,.2796,.49639,.5408,.42969,.6062Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.04929,186.3639c-.0062-.0681,.73671-.2027,1.9406-.3664,.3052-.0338,.5939-.0969,.6437-.3062,.0702-.2211-.0602-.5494-.2111-.9039-.2931-.7368-.6001-1.5096-.9222-2.3193-1.2816-3.3025-2.2117-6.0191-2.07829-6.0696,.13369-.0504,1.28049,2.5855,2.56179,5.8881,.3086,.8145,.6037,1.5908,.8845,2.3336,.1182,.3463,.3203,.7387,.168,1.198-.0805,.2289-.3034,.3966-.4988,.4506-.1954,.0615-.3672,.0662-.5183,.0763-1.2125,.075-1.9647,.0865-1.9699,.0188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.90689,172.8327c-.1154,.3264-1.3115,.1817-2.7137,.3624-1.4064,.1522-2.535,.5722-2.7236,.2821-.0842-.1391,.1105-.4467,.5659-.7654,.4511-.318,1.1727-.6228,2.0146-.7234,.842-.0988,1.6147,.0288,2.1277,.2328,.517,.2033,.7787,.4569,.7291,.6115Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.92789,173.7475c-.2083,.2737-1.0347-.0021-2.0263-.0072-.9909-.04-1.8291,.1973-2.0244-.0855-.0858-.1373,.044-.4106,.40881-.6708,.35919-.2593,.96219-.4736,1.64339-.4585,.6812,.0161,1.2735,.2577,1.62061,.5332,.35239,.2766,.46969,.5558,.37789,.6888Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.26119,169.8189s-2.0929-4.8597-4.45319-5.9787c-2.85751-1.3548-4.058,1.7797-6.77681,1.0433-2.7189-.7367-5.4468-2.0368-8.2023,.0824-3.01589,2.3197-1.5814,3.9185-1.7413,7.3749-.6474,14.0133-3.1737,17.995-3.9541,11.403-.0856-.7222-2.0963-1.2809-2.4181-4.3326-.4173-3.957-.608-8.764,.2533-11.5814,.7259-2.3748,2.06331-4.0222,4.4705-5.8459,3.8003-2.8788,9.0512-2.9821,12.6203-2.652,3.569,.3303,10.4777,4.3789,10.2017,10.487Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.628,183.5281c-.05871-1.2014-1.102-2.142-2.29841-2.0185-1.451,.1495-3.0604,.9872-2.94059,3.9872,.21259,5.3221,5.51219,4.0107,5.51509,3.8578,.0022-.1042-.1674-3.6003-.27609-5.8265Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.66629,187.3985c-.0242-.0161-.0904,.0687-.2441,.1467-.15,.0759-.4108,.1347-.6926,.0419-.5704-.1838-1.0793-1.0575-1.1437-2.0156-.0328-.4837,.0504-.9491,.2066-1.3378,.1468-.3959,.3877-.6779,.6689-.7394,.279-.0764,.4861,.0849,.5572,.2322,.07741,.1458,.048,.2534,.07641,.2614,.01539,.0129,.11059-.0939,.059-.3119-.02631-.1047-.09371-.2278-.22271-.3248-.132-.0991-.3218-.1444-.5181-.1153-.4093,.0448-.7636,.4374-.9354,.864-.1944,.4294-.2993,.9528-.2623,1.4961,.0771,1.0711,.6661,2.0529,1.4444,2.2442,.3783,.0829,.6859-.0427,.8423-.1744,.1596-.1383,.18281-.2585,.1641-.2673Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.96629,168.8955c.0131-.0004,.025,.0041,.0379,.0044,.0319,.0018,.0641,.0018,.09581,.005l-.13371-.0094Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.635,159.5289c-.48861-1.345-1.78591-2.2873-3.176-2.6267-1.39-.3393-2.86071-.1475-4.23881,.2374,.06981-1.9351-2.1007-3.3353-4.0323-3.2013-1.93189,.1339-3.611,1.314-5.1781,2.4516-2.4003-1.3623-5.8702-.173-6.9305,2.3751-1.4297-.7243-3.2426-.6246-4.5841,.2525-1.3415,.8769-2.16,2.4976-2.07,4.0977-1.2498,.2872-2.3039,1.3031-2.637,2.5413-.3333,1.2384,.069,2.646,1.006,3.5213-.8703,.5973-1.2869,1.7824-.9818,2.7927s1.3081,1.7667,2.3633,1.7823l3.7264-3.5573c2.1214,.2987,4.28691-1.5516,4.3226-3.6937,1.6351,.5678,3.5915,.0436,4.7239-1.2651,.3888,.9793,1.2876,1.7393,2.3178,1.9599,1.0305,.2207,2.1617-.1047,2.9172-.8391,.1859,1.4248,1.255,2.6962,2.6267,3.1239,1.3718,.4278,2.9738-.0107,3.9366-1.0772,1.3739,1.0612,3.5589,.8554,4.7107-.4436,1.1517-1.2988,1.09441-3.4928-.1237-4.7297,1.2789-.6417,1.7894-2.3569,1.30111-3.702Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.98769,167.3998c.0189,.004,.0141,.166-.0844,.4433-.0995,.2736-.306,.6668-.7107,1.0308-.3961,.3598-1.0194,.69-1.7717,.6872-.7377,.0044-1.5817-.3054-2.1645-.9894l.3074-.021c-.2484,.3946-.5954,.7456-1.0097,1.0092-.8857,.5596-1.9635,.6811-2.8278,.3928-.8775-.2816-1.466-.9191-1.7932-1.4971-.3322-.5899-.41509-1.144-.4183-1.5123,.0035-.3728,.0713-.5694,.0911-.5658,.0785-.012-.1074,.8563,.5619,1.9374,.3308,.5169,.8881,1.0697,1.6648,1.2974,.7648,.2375,1.72641,.1188,2.514-.3792,.3682-.2345,.6738-.542,.8947-.8835l.1421-.2197,.1654,.1987c.4903,.59,1.2267,.8841,1.8764,.8998,.6587,.024,1.222-.2386,1.6077-.5439,.7832-.6382,.8936-1.317,.9548-1.2847Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M564.749,332.0739s-3.98651,6.02-12.66231,7.4018c-8.6759,1.3818-9.449-1.0747-9.449-1.0747,0,0,8.49131-14.2231,22.11131-6.3271Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.39849,334.7922c-.1107,.1386,4.1372,11.3264,4.1372,11.3264l16.652-5.5992s-2.3846-12.5628-2.7608-12.4708c-.3763,.0919-10.8572-2.2343-18.0284,6.7436Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09029,326.1297c-.51,1.6474-1.9875,31.0158-3.0076,35.409,0,0,5.86531,13.4542,3.0602,21.9661-2.8052,8.5118-2.8052,13.7288-3.0602,21.1424-.255,7.4135-.6215,18.2635-.6215,18.2635l-5.2438-.4161s-5.9381,.3743-6.1931-.724c-.2551-1.0983-2.98729-30.5777-3.4974-40.4624-.51-9.8848,1.53011-14.6792,0-17.4989-1.53-2.8198-1.275-6.1147-1.275-9.135s-3.2077-27.1003-3.2077-27.1003l23.0461-1.4443Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.52539,333.9941s6.2551,25.7616,9.9911,33.8623c3.2208,6.9835,13.0667,2.8044,15.6511-2.6213,.8269-1.7361-.2381-13.0319-2.0375-20.3746-.24509-1-3.5655-16.2996-3.5655-16.2996,0,0-5.4222-.2589-20.0392,5.4332Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M564.749,332.0739c.79109,.1231-9.23031-51.6488-9.23031-51.6488l-50.2848,1.6233s1.4395,39.5335,3.25711,55.6962c0,0,3.51069-4.0211,22.16519-.7639,0,0,2.8383-18.6018,2.7775-17.8012s9.0917,19.3724,9.0917,19.3724c0,0,7.0751-8.8344,22.22361-6.478Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504.29859,286.9548s7.444,4.8973,26.3576,4.8632c19.8173-.0358,26.349-7.9529,26.349-7.9529l-52.7066,3.0897Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M542.52539,338.5519c-.1538,.1106-1.1843-1.8056-2.69739-4.9229-1.51721-3.1233-3.53641-7.4725-5.71311-12.3-.3141-.7-.62389-1.3902-.9171-2.0437l.0659,.089c-.0625-.0805-.12269-.1658-.17769-.252l-.10731-.2047-.20269-.4033c-.12641-.2672-.25191-.5323-.37631-.7954-.24069-.5268-.4774-1.0451-.7098-1.554-.4554-1.0157-.8937-1.9932-1.3117-2.9255-.8283-1.8297-1.575-3.4794-2.2149-4.8929-.6385-1.3775-1.1596-2.4811-1.5375-3.231-.3711-.7537-.59-1.1598-.5567-1.1802,.0233-.0149,.2983,.3605,.723,1.0903,.4317,.7262,1.0024,1.8095,1.6842,3.1705,.6806,1.3616,1.4635,3.0051,2.3213,4.852,.4285,.9275,.8778,1.9,1.3445,2.9104,.2354,.5057,.4751,1.0208,.7187,1.5443,.1245,.2597,.25,.5214,.3764,.7851l.1966,.3872,.0997,.1895,.0378,.0577,.01671,.0303,.00789,.0158c.0015,.0077,.03611-.0266-.1042,.1444l.178-.0389c.2942,.6525,.6049,1.342,.92,2.0411,2.1564,4.7827,4.1072,9.1094,5.5717,12.3576,.68961,1.5108,1.263,2.7671,1.7052,3.7361,.1843,.3893,.3411,.7208,.4767,1.0074,.11271,.2292,.1821,.3358,.1821,.3358Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497.18689,433.2272s5.2666,2.0221,9.9449,2.0087,11.6703-1.0876,14.2401-1.453c2.5699-.3653,9.84,1.1153,10.5678-1.4136s-3.6272-12.4607-3.6272-12.4607c0,0-.98249,2.7862-3.5288,2.4785-2.546-.3079-7.4003-2.045-7.4003-2.045,0,0-1.8781-3.5151-3.3361-3.7648-1.4579-.2496-1.309,3.9577-1.309,3.9577,0,0-3.9918,4.7156-6.5401,5.5969-2.5486,.8814-2.7019,1.6278-5.5761,1.4677-2.8744-.1601-4.3347,.7794-4.3347,.7794,0,0-1.5073,2.24-.9035,3.1395,.6037,.8995,1.803,1.7087,1.803,1.7087Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.35289,431.4671c.5193,.9971,1.823,1.7983,1.823,1.7983,0,0,5.2667,2.022,9.945,2.0085,4.6783-.0133,11.6702-1.0876,14.24011-1.453,2.56979-.3652,9.83989,1.1154,10.56779-1.4136,.2063-.6912,.2253-1.4153,.0619-2.1714,0,0-7.6009,1.4022-11.18869,1.0472-3.58791-.3548-11.44691,1.5429-15.50231,1.1809-4.0554-.3622-8.5436-1.721-8.5436-1.721l-1.274-.8273c-.20709,.5781-.4425,.9706-.1292,1.5514Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.16409,425.5024c.0715,.0014,.0562,.6601,.3874,1.3702,.3186,.716,.8257,1.1364,.7799,1.1915-.0256,.0562-.6466-.3124-.9972-1.0925-.3587-.7762-.22919-1.4868-.1701-1.4692Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.67289,423.6176c.0725-.0062,.1086,.7854,.58,1.6015,.4574,.8243,1.1176,1.2622,1.07511,1.3212-.01811,.0584-.78771-.3176-1.28291-1.2036-.5049-.88-.4317-1.7336-.3722-1.7191Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.49839,421.7716c.064-.0283,.3577,.5392,.8414,1.1486,.4791,.6134,.9617,1.0321,.9191,1.0874-.0342,.0517-.6045-.298-1.1067-.9398-.5057-.6385-.712-1.2751-.6538-1.2962Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.11849,428.3002c.0014,.032-.3708,.0799-.9756,.1128-.6044,.0331-1.4416,.0465-2.365,.0117-.9238-.0354-1.7574-.1123-2.3577-.1913-.6005-.0787-.968-.1548-.964-.1866,.0084-.0687,1.4941,.0717,3.33081,.1393,1.836,.0721,3.32809,.045,3.33149,.1141Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.63679,265.4746c1.3538,.1693,4.1767,.194,4.9805,1.8863,.8038,1.6922-.4697,10.0839-1.3581,9.7455-.8885-.3385-4.4379-2.9491-4.4379-2.9491l.8155-8.6827Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.20939,265.246c.156,1.2139-.7172,8.2385-.7172,8.6332l-3.935,2.2197c-.6675,.3766-1.4906-.1163-1.47-.8825,.0811-3.0236,.2619-8.9753,.438-9.3997,.23681-.5707,5.6842-.5707,5.6842-.5707Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.76279,302.7145c.5956,.7948-1.6922,15.3451-1.6922,15.3451l-4.0599-.5012,1.7667-14.8439h3.9854Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.90249,293.4306c-.0538,.2073,2.1798,6.6012,1.3943,8.6005-.7854,1.9993-3.85579,6.4977-5.4266,5.7837-1.5709-.7141-1.4995-2.3564-1.2853-2.3564s5.14111-2.4277,2.3563-5.7837c-2.7847-3.3559-6.5691,.5713-6.6405,2.2135-.0714,1.6423,3.2845,4.7841,3.2845,4.7841,0,0,1.1425,1.6423-.2856,2.1421s-2.5728-1.5709-3.0001-1.4995-1.4983,.2142-3.1406-.714c-1.6423-.9283-2.0707-2.2135-2.28489-2.2849-.21421-.0714-.85691-4.9983,0-5.9265,.85679-.9283,5.06769-3.1418,5.85409-3.2846s1.91891-2.7108,1.91891-2.7108l7.25549,1.0365Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.23469,302.3615c0,2.1373,1.7327,3.87,3.87,3.87s3.8699-1.7327,3.8699-3.87-1.73259-3.8699-3.8699-3.8699-3.87,1.7326-3.87,3.8699Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.99309,299.9888c.0762,.028-.0723,.5054-.1349,1.284-.0665,.773-.0053,1.8688,.4435,2.9554,.4499,1.0866,1.1807,1.9056,1.7738,2.4057,.5943,.507,1.03651,.7399,1.0023,.8136-.0222,.0575-.5311-.0579-1.2249-.5203-.6883-.4529-1.5384-1.3062-2.0324-2.5-.4933-1.1937-.4944-2.398-.3271-3.2047,.16461-.8174,.4433-1.2587,.4997-1.2337Z",
    style: {
      fill: "#6f4439"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M587.32849,151.9931l.6186,7.2239-.2999,1.3957s.901,3.7621,1.1945,4.521c.2934,.7587,3.0577,4.1653,3.0577,4.1653l-.6822,4.4614,7.2611-.5529s.2562-3.9076,.5631-4.4769c.3067-.5692,.1821-1.7406-.0209-2.4793-.2031-.7387-1.1276-5.2406-1.1276-5.2406,0,0,.7098-5.757-.5455-5.4608-.2866,.0676-.8577,.4094-.8577,.4094,0,0-.313,3.7174-.7292,3.9811l-.7877-.0625s-.7649-5.1192-1.084-5.9962c-.319-.877-.7744-1.3906-1.5025-1.1773,0,0-.4228,.4309-.3716,.6672,.05131,.2364,1.0582,5.8781,.7224,5.916-.336,.0378-.4059-.4839-.4059-.4839,0,0-1.0671-6.9112-1.3076-7.227-.2405-.3159-.80159-.7217-1.41359-.3703l.21369,3.9657s-.6741-3.1118-1.38169-3.4004c-.70771-.2883-1.11351,.2214-1.11351,.2214Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.91059,165.1508c-.0529,.0247-.2575-.5215-.8513-1.2705-.5879-.7283-1.6928-1.6494-3.2346-1.9805l-.1139-.0243-.02-.1038c-.0967-.4992-.1982-1.0225-.3026-1.5617l-.0065-.033,.008-.0367c.0426-.1945,.0764-.4172,.1021-.6366,.0855-.7446,.0686-1.4759-.0986-2.118-.0851-.3179-.205-.6198-.394-.833-.1767-.2202-.4665-.3066-.6814-.2438l.0884-.0858c-.435,1.0188-.80419,1.8617-1.0721,2.4474-.2678,.5856-.4342,.9139-.4636,.9034-.0296-.0105,.0817-.3585,.3017-.9613,.2199-.6028,.5486-1.4602,.9543-2.4895l.0254-.0642,.0632-.0216c.3842-.1306,.79091,.0266,1.0302,.3012,.247,.2698,.3804,.6079,.4793,.952,.1906,.6958,.2106,1.4633,.1219,2.24-.0274,.2319-.0612,.4554-.11,.6751l.0016-.0693c.0996,.5402,.1963,1.0646,.2886,1.5647l-.13369-.1278c1.672,.3825,2.76969,1.3862,3.33969,2.1792,.2856,.403,.46231,.7546,.5586,1.0034,.0959,.2499,.1381,.3875,.1193,.395Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.13979,205.4425l17.29021-1.8826,9.12069-5.9065,4.5164-7.1495,2.77191-19.5781s9.42709-.6368,9.93219-.3552c.5051,.2817-.372,29.5247-2.6691,32.8129-2.297,3.2882-10.0285,11.691-16.9202,14.6687-6.8916,2.9777-16.3831,7.1892-18.8915,10.4191-2.4039,3.0952-9.1775-18.6501-5.1506-23.0288Z",
    style: {
      fill: "#FAAE17"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M556.13979,205.4425c.9455,.8555,4.32921,23.4629,4.32921,23.4629l-5.40951,33.3791s4.30951,19.6558,1.9457,21.5806c-1.4853,1.2095-14.3476,4.4589-26.7889,5.14-7.1428,.3911-13.2189-.5594-20.3374-1.4192-2.8858-.3486-5.3086-.6311-5.5803-.6311-.7091,0,2.1946-68.5341,5.1148-78.8337,0,0,16.1604-3.842,16.4907-3.7766v-3.2658l18.7308,.6854,.20611,3.6465,11.29879,.0319Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.37109,289.0957c-.018,0-.0348-.3069-.0502-.8915-.0105-.6299-.0246-1.4827-.0424-2.5576-.0272-2.2211-.0149-5.4362,.0769-9.407,.1528-7.9434,.717-18.9046,1.45961-30.9968,.74489-12.0968,1.35649-23.0473,1.68649-30.9797,.1508-3.9306,.2734-7.1278,.3604-9.3949,.0448-1.0736,.0803-1.9255,.1065-2.5546,.0302-.584,.0547-.8905,.07261-.8902,.018,.0003,.02859,.3075,.03239,.8922-.0022,.6298-.0052,1.4825-.0088,2.5573-.0093,2.221-.0834,5.4338-.1951,9.4038-.2359,7.9394-.7898,18.9007-1.5346,30.9973-.7427,12.0926-1.3645,23.0415-1.6114,30.9758-.1389,3.9665-.2072,7.1782-.2423,9.3978-.0233,1.0744-.0417,1.9268-.0554,2.5564-.0184,.5845-.03679,.8916-.0547,.8917Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.21609,229.3573c-.0309,.0184-.2148-.2403-.5225-.7265-.3053-.4866-.7168-1.2132-1.14459-2.149-.88151-1.859-1.821-4.57-2.37081-7.6664-.5627-3.0962-.6213-5.9583-.511-8.0083,.0604-1.026,.14181-1.8538,.2381-2.4205,.0889-.5676,.1548-.8782,.1905-.8738,.0857,.0101-.0384,1.27-.0606,3.3057-.0153,2.0336,.10081,4.852,.6556,7.905,.5424,3.0534,1.4107,5.7366,2.1954,7.6104,.7761,1.8795,1.4064,2.9787,1.3299,3.0234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.47349,269.0126c-.1253,.062-1.5359-2.5555-2.9617-5.9295-1.431-3.3732-2.3286-6.2072-2.1969-6.2541,.139-.0504,1.2516,2.6926,2.6764,6.051,1.4196,3.3594,2.6151,6.068,2.4822,6.1326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.62389,254.3972c.13411,.0601-.94789,2.7566-2.2698,6.0832-1.32609,3.3261-2.393,6.0281-2.5317,5.9795-.1328-.046,.7171-2.8343,2.0478-6.1721,1.3266-3.3382,2.6255-5.9484,2.7537-5.8906Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.04159,218.5359c-.0558-.0286-.155,.9333-.2622,2.6591-.1101,1.7285-.2395,4.2327-.383,7.328-.2865,6.1907-.6296,14.7462-.9741,24.1966-.3127,9.428-.5958,17.9595-.8031,24.2077-.0851,3.0524-.1546,5.5435-.2046,7.3368-.0258,.824-.0464,1.4864-.0623,1.995-.0185,.4561-.0355,.6957-.0537,.6957-.0177,0-.0358-.2396-.0512-.6961-.0091-.5089-.0209-1.1718-.0355-1.9965-.0146-1.734-.0046-4.243,.0392-7.3428,.0866-6.1998,.3064-14.7627,.6508-24.2187,.3445-9.4527,.746-18.0084,1.1268-24.1976,.3785-6.1784,.74831-10.0366,1.0129-9.9672Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.13759,231.9629c-.121,.0698-1.1202-1.4559-2.0377-3.5018-.9226-2.0445-1.4013-3.8039-1.26889-3.8482,.13979-.0484,.83219,1.6149,1.74379,3.6345,.9063,2.0212,1.6918,3.643,1.5628,3.7155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.04659,
    y: 263.7318,
    width: 29.5752,
    height: 15.7743,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.95969,
    y: 226.8231,
    width: 9.6019,
    height: 6.3568,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M533.68909,234.3416l-.24409-3.3384c-.003-.1235-.07821-.2011-.17291-.2045-1.0146-.0333-3.498-.1114-4.6953-.1114-.0664-.0039-.1162,.0327-.1357,.0542-.0186,.0205-.0498,.064-.045,.1275l.2334,3.0376-.998,.0761-.2324-3.0366c-.0245-.3227,.08691-.645,.3076-.8838,.2226-.2412,.5205-.3706,.8701-.375,1.168,0,3.4619,.0703,4.7285,.1123,.627,.021,1.127,.5293,1.13871,1.1577l.24309,3.3111-.998,.0732Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.37839,205.5439l9.381,25.9367,5.0554-.2176s-7.959-27.2357-8.4022-27.1185c-.4433,.1172-6.0342,1.3994-6.0342,1.3994Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.38139,205.0836l8.4878,25.239s1.5294-.2369,1.57881-.2293c.04939,.0076-7.63641-25.5686-7.63641-25.5686l-2.4302,.5589Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.12679 204.847 528.75939 231.4806 533.909 231.4806 550.91889 205.2903 545.12679 204.847",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M531.57479,223.2632s-3.6566,6.3242-3.6467,6.3465c.00991,.0222,.8313,1.8709,.8313,1.8709h0l3.5832-5.3846-.7678-2.8328Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M546.95,204.9819s-16.44921,26.3371-16.25531,26.4154l1.6591-.0714,16.8436-26.1777-2.24739-.1663Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M537.15019,240.2878c-.5351,3.361-3.6935,5.6519-7.0545,5.1168-3.361-.535-5.6519-3.6934-5.1169-7.0545,.5351-3.361,3.6935-5.6519,7.0545-5.1168,3.3611,.535,5.652,3.6934,5.1169,7.0545Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.15019,240.2878c-.5351,3.361-3.6935,5.6519-7.0545,5.1168-3.361-.535-5.6519-3.6934-5.1169-7.0545,.5351-3.361,3.6935-5.6519,7.0545-5.1168,3.3611,.535,5.652,3.6934,5.1169,7.0545Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M537.26149,239.5888c-.5351,3.361-3.69349,5.6519-7.05449,5.1168-3.36111-.5351-5.652-3.6935-5.11691-7.0545,.5351-3.361,3.6935-5.6519,7.0545-5.1169,3.3611,.5351,5.652,3.6935,5.1169,7.0546Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M536.22029,239.4946c-.4445,2.7921-3.06829,4.6952-5.8604,4.2507-2.7922-.4445-4.6953-3.0683-4.2508-5.8604s3.0683-4.6953,5.8604-4.2508,4.6953,3.0683,4.2508,5.8605Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M531.87949,234.1994c2.6967,.4293,4.55751,2.8922,4.28151,5.5755,.02019-.0933,.04409-.1849,.05929-.2803,.4445-2.7922-1.4587-5.416-4.2508-5.8605-2.7921-.4444-5.4159,1.4587-5.8604,4.2508-.0152,.0954-.0209,.1899-.0307,.2849,.5709-2.6364,3.1044-4.3997,5.8011-3.9704Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M531.87819,236.0348l.36781,1.1865c.03119,.1007,.11,.1796,.21069,.211l1.1859,.3696c.2535,.079,.3063,.4144,.08941,.5676l-1.01481,.7164c-.0861,.0608-.1368,.1601-.1355,.2655l.0149,1.2421c.0031,.2655-.2995,.4194-.5122,.2604l-.9949-.7437c-.08449-.0631-.1946-.0806-.2944-.0468l-1.1767,.398c-.2516,.085-.49139-.1552-.406-.4066l.3999-1.1761c.0339-.0998,.0166-.2099-.0464-.2945l-.7422-.9961c-.1586-.2129-.0042-.5153,.26131-.5117l1.24209,.0168c.1054,.0015,.2048-.0491,.2657-.1351l.718-1.0136c.1535-.2167,.4888-.1633,.5674,.0903Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.96949,233.6342c1.1971,.1905,2.2286,.7836,2.984,1.6168l1.2897-.1364s-.81419-1.2207-1.936-1.8032l-2.7324,.2802c.13121,.0107,.2625,.0215,.3947,.0426Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.72919,233.7808l-2.6958,.2765s-1.2181,1.1267-1.5478,2.195l1.2565-.1328c.6603-1.1354,1.7345-1.9713,2.9871-2.3387Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.29579,233.3055c-.0371-.0193-.01679-.0088,0,0h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.43739,239.7546c-.13539,.0343-.41639-.6674-.388-1.5802,.024-.9132,.3448-1.5974,.478-1.5554,.1423,.0402,.0632,.7314,.04261,1.5704-.02761,.8385,.01179,1.5332-.13261,1.5652Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.82819,235.9247c.0954,.1085,.1345,.2311,.1067,.29-.0311,.0573-.1532,.0979-.2972,.0849-.1425-.0117-.24469-.1663-.167-.3208,.0789-.1537,.2641-.1624,.3575-.0541Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.93929,237.4413s.599,1.0021,.8739,1.0997,2.2986-.7958,2.3152-1.0583c.0165-.2625-.4032-1.5921-.58539-1.558-.18231,.0341-.82091,1.271-1.01331,1.3288-.1924,.0577-1.2996-.1321-1.5904,.1878Z",
    style: {
      fill: "#fff"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_2--inject-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M363.07009,299.4815c-.5377,.5898,1.6131,8.9952,4.8393,13.5665,3.2263,4.5714,5.9148,2.9493,7.1694,8.4054s1.6131,33.769,0,36.1284-3.5847,4.7188-1.9716,5.1612,7.3486,1.6221,10.0371-1.3272c2.6885-2.9492,3.2262-11.3546,3.047-15.1886-.17929-3.8341,1.0754-23.889-1.4339-27.2806-2.5093-3.3917-7.1693-6.3409-8.78239-9.5851-1.61311-3.2442-3.23491-15.7712-4.12241-16.5159-.8875-.7446-8.7825,6.6359-8.7825,6.6359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M376.14549,339.5521l10.104,7.8173v-6.7789s-10.0946-7.9445-10.104-7.7257,0,6.6873,0,6.6873Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "376.15709 341.3772 376.14139 344.113 386.03329 351.7397 386.19339 349.2248 376.15709 341.3772"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,323.6535c-.09371,.1197-2.307-1.5029-5.18111-3.2721-2.8693-1.7792-5.3088-3.0352-5.2435-3.1727,.0549-.1238,2.6178,.9322,5.5173,2.7297,2.904,1.788,4.9938,3.6107,4.90731,3.7151Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.59329,294.2769c.0175-.004,.0933,.2454,.2221,.724,.1362,.5284,.3161,1.2262,.5411,2.0986,.4708,1.8802,1.1286,4.5068,1.93551,7.7293,.41619,1.6278,.86049,3.4202,1.41059,5.3084,.2245,.9432,.8782,1.6903,1.5788,2.4745,.7027,.7705,1.47861,1.5229,2.2865,2.2819,.8176,.755,1.65511,1.5284,2.5103,2.3182,.2137,.2031,.4257,.4019,.6374,.6349,.2159,.2448,.3661,.438,.5825,.657,.4053,.4255,.8334,.8597,1.2307,1.3316,.78421,.9446,1.4939,2.0579,1.7268,3.3592,.1707,1.2923,.1853,2.5463,.2097,3.8373,.0633,5.1444-.0567,10.0353-.1687,14.4845-.0479,2.219-.1531,4.3498-.17059,6.3033,.05009,1.9764,.05529,3.8372-.15271,5.5232-.351,3.3985-1.75629,5.9425-3.0658,7.3054-.64749,.6981-1.2503,1.1357-1.6741,1.3959-.2077,.138-.3813,.218-.4941,.2769-.1142,.0569-.1745,.0821-.1788,.0742-.0444-.0587,.9576-.4784,2.1963-1.8826,1.2365-1.3804,2.5511-3.8705,2.8506-7.2113,.1812-1.6595,.1558-3.4951,.0869-5.4711-.0011-2.0012,.0879-4.0965,.1226-6.3253,.0856-4.446,.1908-9.3386,.1277-14.4641-.0217-1.2728-.044-2.5634-.1978-3.7485-.204-1.1725-.8607-2.2252-1.6089-3.1292-.3812-.4554-.7945-.8776-1.20689-1.3135-.20261-.2032-.418-.4756-.59131-.6716-.18269-.2031-.3965-.4072-.604-.6055-.85069-.7938-1.6838-1.5711-2.497-2.3299-.8083-.7684-1.5859-1.5322-2.2976-2.3245-.3569-.3947-.6905-.8045-.9958-1.2321-.3085-.4266-.5297-.9502-.6565-1.4252-.5384-1.9158-.96-3.7069-1.3543-5.3441-.7782-3.2748-1.3747-5.9318-1.7754-7.7708-.1854-.8819-.3337-1.5871-.446-2.1212-.0957-.4863-.1373-.7437-.1198-.7478Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.44779,261.9974s.3651,10.3657,1.1091,20.4591c.4823,6.5444,1.124,12.9744,1.9286,16.3898,1.7634,7.4855,11.93551,6.9098,16.8956,1.3397,2.2871-2.5683,3.8121-13.9718,3.5131-21.5258-.0407-1.0288,2.7991-26.44,2.7991-26.44,0,0-10.7871,7.1143-26.2455,9.7772Z",
    style: {
      fill: "#c68c75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.60229,283.0651s10.593-2.59,22.2919,1.5116c0,0-.9896,12.1815-3.0028,15.2919-1.9422,3.0006-7.2317,6.9806-15.2197,3.2459-3.5018-1.6372-4.0694-20.0494-4.0694-20.0494Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.33789,265.1719s-3.5628,3.9796-15.0121,5.3614c-11.4493,1.3818-11.94279-.3667-11.94279-.3667,0,0,8.981-12.8907,26.95489-4.9947Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.42679,299.8498c-.5377,.5898,1.6131,8.9952,4.8393,13.5665,3.2262,4.5714,5.9147,2.9493,7.1694,8.4054,1.2546,5.4561,1.6131,33.769,0,36.1284s-3.5847,4.7188-1.9716,5.1612c1.61311,.4424,7.3486,1.6221,10.03711-1.3272,2.68849-2.9492,3.22619-11.3546,3.047-15.1886-.17931-3.8341,1.07539-23.889-1.43391-27.2807-2.5093-3.3916-7.1694-6.3409-8.7825-9.585-1.6131-3.2442-3.2348-15.7713-4.1223-16.5159s-8.7825,6.6359-8.7825,6.6359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M419.50219,339.9204l10.104,7.8173v-6.7789s-10.0946-7.9445-10.104-7.7257,0,6.6873,0,6.6873Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.51379 341.7455 419.49809 344.4812 429.39 352.108 429.55009 349.5931 419.51379 341.7455"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M426.03669,324.0218c-.0938,.1197-2.307-1.503-5.1811-3.2721-2.8693-1.7792-5.3088-3.0352-5.2435-3.1727,.05491-.1238,2.6178,.9322,5.5172,2.7297,2.9041,1.7879,4.9939,3.6107,4.9074,3.7151Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.98489,300.27c.0179-.0027,.0702,.2315,.15611,.6795,.09129,.5002,.21019,1.1515,.35809,1.9617,.3203,1.6987,.71191,4.1829,1.4257,7.1794,.2318,1.5425,1.5189,2.715,2.76921,4.0134,1.28289,1.2869,2.75459,2.5336,4.243,3.9799,.66339,.8021,1.43159,1.4787,2.12439,2.3468,.6808,.8524,1.2788,1.8515,1.52461,2.9953,.187,1.1635,.18769,2.2777,.22519,3.4377,.026,1.1532,.0314,2.3218,.0321,3.5042-.0106,4.7304-.11829,9.2323-.2351,13.3264-.0443,2.0574-.1763,3.9771-.0943,5.8012,.026,1.825-.0428,3.5398-.29989,5.0838-.48321,3.1121-1.876,5.3837-3.10731,6.6121-.6158,.623-1.1718,1.0223-1.56669,1.255-.19131,.1268-.35441,.1951-.45731,.2507-.1054,.0517-.1612,.0742-.1655,.0664-.0398-.0556,.8709-.4499,2.0422-1.7114,1.1602-1.2468,2.4637-3.4795,2.8909-6.5305,.4883-3.0262,.0442-6.7525,.2783-10.8398,.0903-4.0922,.1833-8.5928,.1939-13.3143-.0099-1.179-.0196-2.344-.0292-3.4923-.032-1.1367-.042-2.2998-.205-3.3372-.2181-1.0403-.7695-1.9815-1.4157-2.7972-.6393-.8139-1.4457-1.5431-2.0814-2.3242-1.4383-1.4159-2.9271-2.7014-4.2026-4.0073-.6419-.6519-1.2493-1.2972-1.7767-1.9776-.2576-.3458-.5133-.6837-.6865-1.0872-.18-.3946-.2582-.7868-.358-1.1651-.6752-3.0397-1.00839-5.5218-1.26839-7.2359-.10811-.817-.195-1.4738-.26171-1.9781-.0525-.4533-.07-.6928-.0524-.6954Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28379,266.4078s6.2551,25.7616,9.9911,33.8622c3.2208,6.9835,13.0667,2.8044,15.65111-2.6212,.82689-1.7361-.23811-13.032-2.03751-20.3746-.2451-1.0001-3.56549-16.2997-3.56549-16.2997,0,0-5.42221-.2589-20.03921,5.4333Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.81519,29.7563h-37.0081c-.1208,.344-2.5889,36.8035,18.5042,37.4913,21.0928-.6878,18.62471-37.1473,18.5039-37.4913Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52959,30.7858h-40.4692c-1.2699,0-2.2993-1.0294-2.2993-2.2993h0c0-1.2699,1.0294-2.2993,2.2993-2.2993h40.4692c1.2698,0,2.2993,1.0294,2.2993,2.2993h0c0,1.2698-1.0295,2.2993-2.2993,2.2993Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.72949,60.9903c-6.6839-1.8533-11.1818-7.0115-13.0071-14.9163-1.34639-5.8309-.766-11.0536-.7406-11.2731l.1309-1.1309h9.49131v2.575h-7.29271c-.0886,1.78-.1135,5.4306,.78671,9.2846,1.63249,6.9894,5.41619,11.353,11.24649,12.9696l-.615,2.4911Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.81229,60.9903l-.615-2.4911c5.8502-1.6221,9.6392-6.0086,11.2623-13.0375,.8871-3.8423,.8612-7.4512,.7719-9.2167h-7.2937v-2.575h9.4913l.1308,1.1309c.0254,.2195,.6058,5.4422-.7407,11.2731-1.8253,7.9048-6.323,13.0629-13.0069,14.9163Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.23519,69.054c-.8429-4.5185-1.169-7.6269-1.216-9.7652h-4.9239c-.047,2.1383-.3731,5.2467-1.216,9.7652-2.7498,14.7412-12.6088,15.5406-12.6088,15.5406v4.1737h32.57351v-4.1737s-9.859-.7994-12.60881-15.5406Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.96659,30.8908c0,.1439-9.2248,.2605-20.60159,.2605-11.38081,0-20.60361-.1166-20.60361-.2605,0-.1437,9.2228-.2603,20.60361-.2603,11.37679,0,20.60159,.1166,20.60159,.2603Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.844,84.5946c0,.1438-7.29241,.2604-16.286,.2604-8.99661,0-16.28751-.1166-16.28751-.2604s7.2909-.2604,16.28751-.2604c8.99359,0,16.286,.1166,16.286,.2604Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.70619,54.6582c.0171,.0055-.0144,.1461-.0906,.4098-.0809,.2618-.1859,.6547-.3688,1.1434-.3724,.9731-.9785,2.3721-2.0267,3.9304-1.055,1.5391-2.5385,3.2792-4.6244,4.6583-2.052,1.4016-4.712,2.4281-7.6014,2.5686-2.8981,.1436-5.6319-.6623-7.8054-1.8661-2.1862-1.2081-3.8581-2.7649-5.0023-4.2514-1.1519-1.4853-1.8415-2.8558-2.2054-3.8349-.208-.4798-.2897-.8824-.3751-1.1424-.0742-.2644-.1046-.4051-.0874-.4103,.1302-.066,.6145,2.2876,2.9548,5.1568,1.1547,1.4245,2.8099,2.9107,4.9442,4.0604,2.12331,1.146,4.764,1.9057,7.5505,1.7678,2.7862-.1361,5.3554-1.1095,7.3619-2.4481,2.0384-1.3156,3.5145-2.9858,4.5874-4.4686,2.11351-3.0317,2.6672-5.3292,2.7887-5.2737Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.22109,67.1341l-.3418,1.9199s3.8144,1.4237,7.3343-.1163l-.42959-2.3863-6.56291,.5827Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.33789,265.1719s-7.5592-57.9414-12.0877-57.2558l-45.8629,2.1714c-2.4648,.0384-6.6924,43.6157-4.4552,60.3752,0,0,8.1107-3.2571,26.7652,0,0,0,2.8383-17.6217,2.7775-16.8211-.06079,.8006,5.90821,16.525,5.90821,16.525,0,0,11.65579-4.0124,26.95489-4.9947Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M356.44779,216.5145s5.71721,12.9242,24.2495,9.1452c18.5322-3.7789,24.8625-11.3929,24.8625-11.3929l-49.112,2.2477Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M389.38289,270.1665c-.1598,.0903-.98289-1.9283-2.1667-5.1951-1.1869-3.2729-2.7495-7.8199-4.4229-12.8588-.5505-1.6752-1.0832-3.2966-1.5806-4.8105l.0842,.1197c-1.6196-1.2859-2.9793-2.6316-4.216-3.8157-1.2134-1.1668-2.3003-2.212-3.2308-3.1068-.9162-.8611-1.6632-1.5287-2.1756-1.9884-.516-.455-.7916-.7096-.77249-.7339,.01779-.0228,.32929,.1866,.88139,.6019,.5483,.4198,1.3313,1.0528,2.28061,1.8845,.95039,.8304,2.06469,1.861,3.31459,3.0296,1.2555,1.1596,2.63141,2.4854,4.2268,3.7323l.0602,.0471,.0243,.0729c.5028,1.5116,1.0413,3.1305,1.5976,4.8032,1.6552,4.9936,3.1526,9.5112,4.27651,12.9021,.52929,1.5792,.96929,2.8923,1.30859,3.9046,.142,.4081,.2629,.7555,.36741,1.0556,.08709,.2408,.14289,.3557,.14289,.3557Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.14389,139.0979c.9455,.8555,9.3662,23.6492,9.3662,23.6492l-5.4095,33.3791s1.6871,12.5162,2.6486,17.3415c.3744,1.8785-16.1227,5.2343-26.45619,7.2216-7.02481,1.3509-13.47791,.7117-19.98921-2.0858-2.6707-1.1475-5.93379-2.7836-5.9339-3.0553-.0014-4.3764,1.97311-11.063,1.97311-11.063,0,0-.45381-44.6567,.54249-50.8441,.7458-4.6315,9.7069-15.3021,9.7069-15.3021l33.5515,.7589Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.46979,
    y: 183.1092,
    width: 29.57521,
    height: 15.7743,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.54239,131.2426l-1.8273-11.6464v-.0002c-.5382-3.4306-1.7669-54.6271-1.7669-54.6271l-6.1514,.916s-9.5865,25.5211-9.3767,33.7025c.1501,5.8568,2.306,15.716,3.5193,20.8471,.0893,7.2942,.28361,22.7464,.28361,22.7464l3.34819,14.7621c.5284-.3419,15.3366-19.1476,15.3366-19.1476l-3.3654-7.5528Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M388.26,96.4024l-.73081-.0294c-7.3527-.2954-13.7021,5.1026-14.5873,12.408-.824,6.7969-1.6471,14.3174-1.7488,17.9774-.2106,7.577,7.3167,9.0591,7.3167,9.0591,.0171,.0016-.25,3.0624-.25,3.0624l5.19321,9.8641,11.67919-9.7321,3.7265-26.8864c.9939-7.8363-2.7378-14.9464-10.59869-15.7231Z",
    style: {
      fill: "#c68c75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.46049,135.8175s4.7624,.4718,9.9781-2.519c0,0-2.57559,5.7146-10.1051,4.7291l.127-2.2101Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.48709,121.6932c.00791-.0658-.7105-.22-1.8765-.417-.2962-.0425-.5751-.1128-.6169-.3176-.0613-.2176,.0759-.533,.2338-.873,.3081-.708,.6311-1.4502,.9697-2.2277,1.35-3.1731,2.3399-5.7866,2.2117-5.84-.1285-.0531-1.3268,2.4753-2.6764,5.6483-.3256,.783-.637,1.5288-.9334,2.2427-.1259,.3332-.3345,.7085-.20109,1.1602,.07119,.2253,.28289,.3953,.47119,.4541,.1883,.0657,.3553,.0757,.5022,.0904,1.1769,.111,1.9084,.1456,1.9157,.0796Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.818,117.5325c.13109-.0507,5.66849-1.154,5.29509,4.0169-.3734,5.1707-6.26909,3.8452-6.2674,3.6961,.0017-.149,.97231-7.713,.97231-7.713Z",
    style: {
      fill: "#c68c75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76329,123.077c.0238-.0149,.0858,.0695,.2329,.1503,.1435,.0787,.3956,.1438,.6722,.0624,.5608-.161,1.0835-.9951,1.1759-1.9253,.0472-.4695-.0192-.925-.1589-1.3079-.1309-.3895-.3563-.6717-.6278-.7403-.2692-.0831-.4757,.0675-.5495,.2085-.0796,.1394-.0542,.2452-.0824,.2521-.0154,.0119-.1048-.0947-.0476-.3051,.0288-.1013,.0981-.219,.2268-.3094,.1313-.0921,.3176-.1304,.5075-.0958,.3968,.0564,.7292,.4492,.8834,.8696,.1755,.4238,.2611,.9365,.208,1.4639-.1082,1.0394-.7119,1.9763-1.4752,2.1381-.3707,.0688-.6662-.0629-.8139-.1961-.151-.1395-.1699-.2569-.1514-.265Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.24069,106.2145c3.1988,.7641,6.5424,.7952,9.2944-1.0059,.7918-.5182,1.53891-1.1224,2.233-1.7905,1.2541-1.207,2.2822-2.7575,3.8925-3.4186,2.0761-.852,4.4172,.0387,6.4805,.9215l-.0839-.0871c1.0647,.5858,2.0152,1.3787,2.7825,2.3212-.9145,4.9389-.5518,10.1118,1.0774,14.8665,.1338,.3903,.4081,.7268,.7783,.9095,1.17061,.5781,.9271-1.0595,1.852-1.2958,.7087-.1813,1.0317-.0086,2.4061,.0638,.5826-1.26,1.1506-4.7745,1.7101-6.6544,1.2287-1.105,2.4585-3.241,2.64141-4.9735,.18289-1.7325-.6-4.0226-.6-4.0226-1.10811-2.593-1.76331-3.9244-3.71581-4.7788l-.0466,.0165c-1.7475-.8491-3.9634-1.0151-5.5273,.1295-.1768-2.7228-2.391-5.0246-4.9755-5.9004-2.5844-.8752-6.83579-.7598-9.4322,.0797-1.7715,.5724-3.5384,1.7923-5.6195,3.5853l.00091-.0014-.00181,.0024c-.2766,.2383-.5578,.485-.84619,.7436-.02441,.0216-.04621,.0459-.07,.0676-.58581,.31-1.28831,.4214-2.007,.4435-1.15711,.0352-1.84261-.3839-2.55251-1.2987-.2158-.2782-.48649-.6289-.8297-.5492-.2165,.0504-.354,.2615-.4405,.4662-.461,1.09-.0701,2.4006,.7073,3.2933,.3765,.4323,.8308,.78,1.3229,1.0742,0,0-.8418,.8832-2.1758,.99-.7156,.0572-1.3883,.4139-1.837,.9742-.21869,.2732-.3861,.6015-.4171,.982-.1778,2.1782,1.9143,3.3483,3.9991,3.8464Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.04039,103.8391c-.0019,.0023,.0173,.0213,.057,.0562,.0485,.0407,.10761,.0903,.1794,.151,.0784,.0677,.1783,.1474,.30621,.2283,.12549,.0839,.26809,.1854,.44349,.2746,.67951,.3832,1.7837,.7943,3.1989,.8102,1.4014,.0193,3.112-.3577,4.6864-1.3663,1.5886-.9814,3.0281-2.49,4.2419-4.2481,.6151-.8777,1.1294-1.786,1.6851-2.6188,.55221-.8338,1.1511-1.5984,1.853-2.1855,.694-.5915,1.4813-1.0092,2.2738-1.1708,.3953-.0882,.7876-.0866,1.15941-.0518,.37209,.0459,.72019,.1463,1.03869,.2762,.6372,.2648,1.1382,.662,1.5114,1.0608,.3746,.4022,.6158,.8162,.7767,1.1679,.2954,.72,.2831,1.1679,.3109,1.1623,.00331-.0002,.003-.027-.0005-.0798-.0053-.0635-.0118-.1404-.0194-.2341-.0229-.2054-.0897-.5052-.2275-.8751-.1537-.3622-.3908-.7903-.7669-1.2082-.3746-.4144-.8822-.8293-1.5355-1.1095-.3266-.1375-.6856-.245-1.0711-.2962-.3847-.0405-.796-.0446-1.2052,.0433-.8228,.1609-1.6369,.5883-2.35,1.1899-.7217,.5978-1.334,1.3755-1.8924,2.2142-.562,.8386-1.0767,1.7444-1.6863,2.6142-1.2048,1.7448-2.6235,3.2369-4.1826,4.2103-1.54629,1.001-3.2171,1.3814-4.5991,1.3795-1.3927,.0003-2.485-.3852-3.1669-.7455-.6868-.3656-1.0036-.6697-1.0189-.6492Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.58479,100.4648c-.0069,.0102,.0851,.0837,.2583,.2081,.17091,.1279,.4357,.2892,.7753,.4645,.3382,.1786,.7608,.3528,1.2432,.5073,.4846,.146,1.0305,.2673,1.6123,.3303,.5826,.0562,1.1417,.0481,1.6459,.0037,.5038-.054,.9529-.1387,1.3204-.2446,.3679-.1034,.6599-.2076,.8532-.2981,.195-.0869,.2998-.1401,.295-.151-.0125-.0313-.4456,.1545-1.1789,.3272-.366,.0894-.8092,.1599-1.3039,.2034-.4955,.0348-1.0429,.0379-1.6137-.0173-.5698-.0617-1.1055-.1757-1.5833-.31-.4754-.1433-.8954-.3022-1.2357-.4635-.6828-.3182-1.0695-.5877-1.0881-.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17229,106.7571c-.0198-.0027-.0647,.1659-.1101,.4803-.0449,.3143-.08819,.7754-.0833,1.3525,.0144,.2948-.0088,.5899,.0793,.9668,.0405,.182,.2257,.4175,.4866,.4207,.2489,.0041,.43421-.1208,.5976-.2369,.6148-.4829,1.2817-1.0065,1.9863-1.5598l-.2589-.1795c-.115,.3498-.2351,.7151-.3573,1.0875-.3287,1.0218-.6412,1.9935-.9274,2.8835l-.1553,.483,.3941-.3157c1.0474-.8395,1.7906-1.7109,2.2563-2.3573,.4662-.649,.6722-1.067,.64681-1.0823-.07211-.0602-1.00941,1.5853-3.09111,3.1997l.2388,.1672c.2945-.8873,.6159-1.8559,.9539-2.8748,.1211-.3727,.2401-.7386,.3538-1.0887l.17161-.5286-.43061,.3489c-.6939,.5623-1.3507,1.0946-1.9562,1.5852-.1393,.1098-.2926,.196-.4124,.1935-.118-.0006-.2054-.0853-.251-.2243-.0792-.2804-.0826-.6226-.1074-.8956-.0629-1.1313,.025-1.8202-.0241-1.8253Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.37839,116.3696c-.0445,.5832,.4069,1.1011,1.0075,1.1579,.5994,.0562,1.122-.3694,1.1662-.9529,.0442-.5833-.4068-1.1019-1.0063-1.1586-.6004-.0566-1.1234,.3702-1.1674,.9536Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12649,112.2229c.1296,.1497,.9821-.4379,2.1574-.388,1.1743,.0324,2.0119,.6791,2.14511,.5382,.06519-.0619-.06191-.3279-.42611-.6198-.3585-.2903-.978-.5836-1.7104-.6093-.732-.0247-1.359,.2235-1.7243,.489-.3727,.2666-.5059,.5224-.4417,.5899Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.62259,116.7698c-.0442,.5833,.4071,1.1011,1.0077,1.1576,.5993,.0567,1.1221-.369,1.1662-.9526,.044-.5834-.4071-1.1018-1.00649-1.1585-.60051-.0567-1.12321,.3703-1.16741,.9535Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.63479,112.9552c.1297,.1497,.9835-.4374,2.1575-.3878,1.1743,.0328,2.012,.6792,2.14571,.5384,.06469-.062-.06111-.3277-.42691-.6196-.3582-.2904-.9778-.5836-1.71-.6098-.73209-.0247-1.359,.224-1.7246,.4888-.3717,.267-.5053,.523-.4417,.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.406,109.2169c.14729,.3103,1.30059,.0359,2.69,.0607,1.39039-.0036,2.538,.2883,2.69129-.0194,.0676-.1468-.1555-.4298-.63429-.6951-.47431-.2654-1.21171-.4878-2.04551-.495-.833-.0055-1.5746,.2056-2.0544,.4633-.4835,.2581-.71209,.5377-.64709,.6855Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.215,108.7209c.22929,.2833,1.20089,.0552,2.35149,.1051,1.1516,.0155,2.113,.298,2.3529,.0274,.1057-.1314-.0325-.4106-.4435-.6897-.4051-.2778-1.0948-.5244-1.8861-.5471-.7912-.022-1.4893,.1856-1.9047,.4401-.4215,.2554-.5704,.5264-.47009,.6642Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M382.22359,124.0115c.8588-.4018,1.7201-.8048,2.6215-1.0989,.2878-.0939,.6036-.1761,.8875-.0711,.3207,.1186,.5133,.4435,.6462,.7585,.1988,.471,.3227,1.0024,.1776,1.4927-.1192,.4027-.4105,.7373-.7508,.9835-.3404,.246-.7302,.4133-1.1177,.5753-.4717,.1972-.9906,.3928-1.48189,.2509-.39251-.1133-.69921-.43-.90041-.7856-.3481-.6154-.9112-1.7937-.082-2.1053Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.727,126.9487c.00169-.0853,.63259-.0424,1.54259-.3583,.44441-.1615,.976-.4207,1.4219-.8297,.4688-.3959,.5992-1.0227,.5167-1.7591-.0287-.351-.1309-.6539-.3315-.8252-.1861-.1685-.46269-.1745-.7513-.0952-.5719,.1824-1.1508,.4502-1.6098,.6126-.934,.3544-1.5259,.5406-1.55459,.4747-.02861-.066,.51149-.3716,1.40779-.8125,.4645-.2141,.9486-.4887,1.62421-.7361,.32649-.1115,.83739-.1546,1.21279,.1666,.36121,.3002,.488,.7678,.5209,1.1658,.0342,.3963,.0368,.8014-.0761,1.1968-.1095,.4001-.3663,.7362-.6368,.967-.5503,.4629-1.13479,.6932-1.6375,.8268-1.0202,.2466-1.66229,.061-1.64929,.0058Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.62929,60.9493s2.6701-4.6727,2.5588-6.3415l-.1112-1.6689s-.4383-1.0012,.1146-2.3363,0-2.5589,0-2.5589c0,0,2.333-1.5576,1.1092-2.4476s-3.5602-2.2251-4.67269-2.2251c-1.11261,0-4.00521,.445-4.339,1.1125-.33381,.6676,0,1.7801,0,1.7801,0,0-.29671,.5563-.14831,2.0026,0,0-1.1215,.3338-.0416,2.3364,0,0-1.2417,1.611-.0262,3.5023,0,0,1.6849-.0856,2.0187,1.2494,.3338,1.3351-2.75059,1.6587-2.5407,3.5501,.2099,1.8913,.6713,5.8367,.6713,5.8367,0,0,6.9142,.262,6.9142-.0718,0-.3337-1.5071-3.72-1.5071-3.72Z",
    style: {
      fill: "#c68c75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.07889,52.9009c-.0787,.0197-.1884-.3062-.5208-.7015-.3245-.3965-.9062-.8442-1.6546-1.088-.7549-.2435-1.502-.2833-2.0443-.3197-.5444-.0327-.8906-.065-.8954-.1389-.0046-.0695,.3289-.1672,.8873-.2293,.5536-.0568,1.35891-.0813,2.2143,.1929,.8603,.2786,1.5048,.8569,1.7948,1.3724,.29981,.5195,.2791,.9049,.2187,.9121Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.77229,49.0898c-.0898,.1265-1.1991-.6677-2.8018-.8516-1.5993-.2158-2.86949,.2814-2.92549,.1367-.08481-.1073,1.22049-.8845,2.99-.6535,1.77139,.211,2.84589,1.2852,2.73729,1.3684Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.77239,46.6409c-.0782,.1363-1.4148-.6764-3.2681-.7809-1.8517-.1382-3.2825,.4933-3.34229,.348-.08721-.1028,1.36179-1.011,3.37639-.8677,2.0153,.1206,3.3338,1.21,3.234,1.3006Z",
    style: {
      fill: "#6f4439"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M359.73209,64.5462s-2.6909-5.8609-2.5797-7.5297l.1113-1.6688s.4382-1.0013-.1146-2.3364c-.5529-1.335,0-2.5588,0-2.5588,0,0-2.333-1.5576-1.1092-2.4477,1.2238-.89,3.56011-2.2251,4.6727-2.2251s4.0052,.445,4.339,1.1126c.3337,.6675,0,1.7801,0,1.7801,0,0,.2966,.5562,.1483,2.0026,0,0,1.1215,.3337,.0415,2.3363,0,0,1.685,.3338,.4695,2.2251,0,0-1.4381,.2225-1.77189,1.5576-.33381,1.3351,2.42239,1.8913,2.21249,3.7827-.2099,1.8913-.2292,6.1939-.2292,6.1939,0,0-6.4879,.6972-6.4879,.3635,0-.3338,.2977-2.5879,.2977-2.5879Z",
    style: {
      fill: "#c68c75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.72459,47.9635c-.0192,.1569-2.00659-.4798-4.2609,.3476-2.2605,.8127-3.3755,2.5765-3.4909,2.4683-.0545-.0318,.1365-.5113,.6716-1.1418,.5273-.6273,1.4405-1.3801,2.6415-1.816,1.2003-.4363,2.3837-.4453,3.1906-.3027,.8151,.14,1.2694,.3852,1.2481,.4446Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.59879,50.7701c-.0562-.123,1.1269-.7039,2.7216-.7517,1.5948-.0589,2.8138,.4418,2.7659,.5681-.0406,.1472-1.25129-.1054-2.7486-.0476-1.4972,.0423-2.6886,.3753-2.7389,.2312Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.67839,53.8651c-.1072-.1152,.8765-.8981,2.32761-1.0312,1.10729-.1184,2.027,.0171,2.36889,.1142l-.0748,.1444c-.0419-.1038-.05009-.1661-.0245-.1851,.0255-.0189,.0827,.007,.1699,.0772l.1126,.0906-.1874,.054c-.3474,.1001-1.26869,.1098-2.3046,.2221-1.3404,.1218-2.308,.6253-2.3877,.5138Z",
    style: {
      fill: "#6f4439"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.89,119.2619c-.04711-.2113-.104-.4063-.15851-.6055l-1.8779-16.577c.6018-6.6201,1.6337-6.3444-.1718-13.2655-1.8055-6.921-11.564-26.7564-11.564-26.7564h-5.7174c-.6019,1.8055,.3009,34.0036,3.0092,37.9156,2.7081,3.9117,2.3325,12.5849,2.2775,14.4928l-2.8133,22.7885-4.1119,3.8182c.2937,9.1049,11.4066,23.7826,11.4066,23.7826,0,0,5.4107-9.7869,8.3478-18.3043,2.937-8.5174,1.5656-26.429,1.37371-27.289Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.85119,167.4847l-.2441-3.3384c-.003-.124-.0782-.2007-.1729-.2041-1.2656-.0415-3.5547-.1118-4.6943-.1118-.0645-.0025-.1162,.0327-.1358,.0542-.0195,.0205-.0498,.0644-.0449,.1289l.2324,3.0366-.9961,.0762-.2334-3.0371c-.0253-.3242,.08791-.6465,.3086-.8843,.2237-.2412,.5459-.3686,.8692-.3745,1.1543,0,3.456,.0703,4.7275,.1128,.628,.02,1.128,.5288,1.1387,1.1582l.2432,3.31-.9981,.0733Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.90789,138.1419l6.01411,26.4819,5.05539-.2175s-5.4435-26.3473-5.8867-26.2301c-.4432,.1173-5.1828-.0343-5.1828-.0343Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.88889,138.1941l5.1429,25.2718s1.5294-.2369,1.5789-.2293c.0494,.0076-4.6133-25.059-4.6133-25.059l-2.1085,.0165Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.48079 138.4989 378.922 164.6238 383.97739 164.4063 402.02259 137.9903 396.48079 138.4989",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M382.256,156.1909s-3.91931,6.081-3.90941,6.1032l.57541,2.3297h0l3.84209-5.7735-.50809-2.6594Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M398.18679,138.3423s-17.5234,26.12-17.3295,26.1983l1.6592-.0714,17.48-26.293-1.8097,.1661Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M387.31279,173.4311c-.535,3.361-3.6935,5.6519-7.0545,5.1168s-5.6519-3.6935-5.1168-7.0545c.535-3.361,3.6934-5.6519,7.05451-5.1169,3.361,.5351,5.65189,3.6935,5.11679,7.0546Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.31279,173.4311c-.535,3.361-3.6935,5.6519-7.0545,5.1168s-5.6519-3.6935-5.1168-7.0545c.535-3.361,3.6934-5.6519,7.05451-5.1169,3.361,.5351,5.65189,3.6935,5.11679,7.0546Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.42409,172.732c-.53509,3.3611-3.6935,5.652-7.0545,5.1169s-5.6519-3.6935-5.1169-7.0545c.5351-3.3611,3.6935-5.652,7.0545-5.1169,3.3611,.5351,5.652,3.6935,5.1169,7.0545Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M386.38289,172.6378c-.4445,2.7921-3.0683,4.6953-5.8604,4.2508s-4.6953-3.0683-4.2508-5.8604c.4445-2.7922,3.06831-4.6953,5.8604-4.2508,2.7922,.4445,4.6953,3.0683,4.2508,5.8604Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M382.04209,167.3427c2.6967,.4293,4.5575,2.8921,4.2815,5.5755,.0202-.0933,.0441-.1849,.0593-.2804,.4445-2.7921-1.4587-5.4159-4.2508-5.8604-2.79209-.4445-5.4159,1.4586-5.8604,4.2508-.0152,.0954-.0209,.1899-.03069,.2848,.57089-2.6363,3.10449-4.3996,5.80109-3.9703Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M382.04089,169.1781l.3677,1.1865c.0313,.1007,.11,.1796,.2107,.2109l1.1859,.3697c.2535,.079,.3063,.4144,.0894,.5675l-1.0147,.7165c-.0862,.0608-.13689,.1601-.1356,.2655l.0149,1.2421c.0032,.2655-.2995,.4194-.5121,.2604l-.995-.7437c-.0844-.0631-.1945-.0806-.2944-.0469l-1.17669,.398c-.25151,.0851-.49141-.1552-.406-.4065l.39989-1.1761c.0339-.0998,.0166-.21-.0464-.2945l-.7421-.9962c-.1587-.2129-.0043-.5153,.2612-.5117l1.2421,.0169c.1054,.0014,.2048-.0491,.2657-.1351l.7181-1.0137c.1534-.2166,.4887-.1632,.5674,.0904Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.13219,166.7774c1.197,.1906,2.2286,.7836,2.9839,1.6169l1.2897-.1364s-.8141-1.2207-1.936-1.8032l-2.7324,.2802c.1312,.0106,.2625,.0215,.3948,.0425Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.89179,166.9241l-2.6957,.2765s-1.21809,1.1267-1.5478,2.195l1.2564-.1329c.66031-1.1353,1.7345-1.9713,2.9871-2.3386Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.45839,166.4488c-.0371-.0193-.0168-.0088,0,0h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.6,172.8979c-.13541,.0343-.41641-.6674-.388-1.5802,.024-.9132,.34479-1.5974,.478-1.5554,.14229,.0401,.06319,.7313,.04259,1.5704-.02759,.8385,.0118,1.5332-.13259,1.5652Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.99089,169.0679c.0954,.1086,.1345,.2312,.1066,.2901-.0311,.0572-.1532,.0979-.2971,.0849-.1426-.0117-.2448-.1663-.1671-.3208,.0789-.1538,.2641-.1624,.3576-.0542Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.10189,170.5846s.599,1.0021,.8739,1.0997,2.2986-.7958,2.31521-1.0583c.01649-.2626-.40321-1.5921-.58541-1.558s-.8208,1.271-1.0133,1.3287c-.1924,.0578-1.2996-.132-1.5904,.1879Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 390.12689,
    y: 159.6869,
    width: 9.6019,
    height: 6.3568,
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.67939,156.7781c-.0569,.0306-.4926-.622-1.0382-1.7646-.54619-1.1406-1.1737-2.7851-1.6119-4.6711-.4345-1.8875-.5926-3.6407-.6026-4.9053-.0115-1.2662,.0935-2.0436,.1581-2.0411,.1644-.0005,.0788,3.1213,.9519,6.8291,.843,3.7134,2.2906,6.4813,2.1427,6.553Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.76489,38.4215l1.4487,2.9355c.134,.2715,.393,.4597,.6926,.5032l3.2396,.4707c.7544,.1097,1.0557,1.0368,.5097,1.569l-2.3441,2.285c-.2168,.2113-.3157,.5158-.2646,.8142l.5534,3.2264c.1289,.7514-.6598,1.3245-1.3346,.9697l-2.8975-1.5233c-.268-.1409-.58809-.1409-.85609,0l-2.89751,1.5233c-.6749,.3548-1.4636-.2183-1.3347-.9697l.5534-3.2264c.0512-.2984-.0478-.6029-.2646-.8142l-2.3441-2.285c-.5459-.5322-.2447-1.4593,.5098-1.569l3.2395-.4707c.2996-.0435,.5586-.2317,.6926-.5032l1.4488-2.9355c.3374-.6837,1.3123-.6837,1.6497,0Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_1--inject-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.9029,163.226c-.8824,1.8529,24.6013,93.086,27.8756,94.7469,3.2744,1.6608,2.5768-13.7531,18.2209-14.0852,15.6442-.3322,52.7535,9.6329,74.9464-3.3217,22.1929-12.9547,42.7601-20.5387,64.5892-19.7585l-22.81041-92.6245s-159.18359,27.4031-162.82169,35.043Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.8525,191.3291l162.40589-36.6149,7.5601,30.6987s-128.75019,31.3212-137.95579,29.963c-9.2056-1.3581-21.381,10.1389-21.381,10.1389l-10.6292-34.1857Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.4445,179.1029c.3075,1.1467,20.0007,26.2873,24.5586,27.5853,4.5578,1.298,41.2295,2.5683,41.2295,2.5683l45.7132,31.3095,6.3543-3.582s1.6842-26.0816,5.4518-34.1959c3.7677-8.1142,4.2753-8.1021,4.6494-7.7314s18.2147,3.0021,25.7464-3.4627c7.5318-6.4648,11.184-16.2789,10.03631-20.9392-.46581-1.8914-52.8174,13.4454-52.8174,13.4454,0,0-6.824-9.0059-6.5128-12.2773,.3111-3.2713-6.3157-23.8193-7.4754-23.3287-1.1596,.4906-23.8794,41.0989-23.8794,41.0989,0,0-42.0787,3.2699-43.6363,3.5474s-29.4182-14.0376-29.4182-14.0376Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M204.6107,236.6725c-.0043,.0079-.0775-.0232-.2166-.0916-.1654-.0854-.366-.1889-.6111-.3153-.5709-.3085-1.3473-.728-2.3272-1.2574-2.037-1.065-4.8785-2.7977-8.3237-5.0378-1.6768-1.1871-3.5913-2.3821-5.489-3.8816-.9635-.7309-1.9595-1.4864-2.9849-2.2643-.9926-.8212-2.0136-1.6659-3.0603-2.5319-4.1516-3.5083-8.5118-7.6058-12.8577-12.1249-8.6443-9.0908-15.9685-17.755-21.5249-23.7935-2.7706-3.0257-5.0227-5.4661-6.6149-7.1184-.7619-.8111-1.3656-1.4538-1.8095-1.9264l-.4613-.5104c-.1019-.117-.151-.1801-.1446-.1865,.0064-.0063,.068,.0442,.1823,.149,.1348,.1283,.2984,.2839,.4982,.4741,.4612,.456,1.0885,1.0762,1.8802,1.8589,1.6381,1.61,3.9329,4.0139,6.7405,7.0104,5.6304,5.9798,13.0037,14.6109,21.6293,23.6818,4.3366,4.5093,8.672,8.6032,12.7925,12.1197,1.0384,.8689,2.0513,1.7164,3.0359,2.5403,1.0165,.7822,2.0037,1.542,2.9589,2.2771,1.8801,1.5096,3.7762,2.7178,5.4349,3.9212,3.4091,2.2725,6.2151,4.0495,8.2184,5.167,.9587,.5648,1.7184,1.0123,2.2769,1.3413,.2352,.1447,.4277,.263,.5863,.3606,.1307,.0838,.1956,.1307,.1914,.1386Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.4408,297.0478c-.3398,1.6949,1.674,31.0398,1.1283,35.5208,0,0,7.8577,12.696,5.9217,21.4726s-1.3,13.9594-.6666,21.3536c.6334,7.3941,1.5675,18.2149,1.5675,18.2149l-5.6094,.1858s-6.2492,1.0502-6.6534-.0118c-.4043-1.0619-6.8943-30.0362-8.6399-39.7979-1.7457-9.7618-.1675-14.7579-2.1332-17.3844-1.9657-2.6264-2.0971-5.9289-2.4652-8.9295-.3682-3.0005-6.7041-26.5563-6.7041-26.5563l24.2543-4.0678Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.7402,290.5199c-1.1855,.9028,.6264,42.8752,3.4583,49.0603s7.9726,6.4383,7.9726,6.4383c0,0-1.6047-6.4951-5.5781-14.06,0,0,.7064-33.3602,.9367-33.4669,.3633-.1683-6.7895-7.9717-6.7895-7.9717Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.9293,404.3986s5.2666,2.0221,9.9449,2.0087,11.6703-1.0876,14.2401-1.453c2.5699-.3653,9.84,1.1153,10.5678-1.4136s-3.6272-12.4607-3.6272-12.4607c0,0-.9825,2.7862-3.5287,2.4785-2.5461-.3079-7.4004-2.045-7.4004-2.045,0,0-1.8781-3.5151-3.3361-3.7648-1.4579-.2496-1.309,3.9577-1.309,3.9577,0,0-3.9918,4.7156-6.5401,5.5969-2.5486,.8814-2.7019,1.6278-5.5761,1.4677-2.8744-.1601-4.3347,.7794-4.3347,.7794,0,0-1.5073,2.24-.9035,3.1395,.6037,.8995,1.803,1.7087,1.803,1.7087Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.0953,402.6385c.5194,.9971,1.823,1.7983,1.823,1.7983,0,0,5.2667,2.022,9.945,2.0085,4.6783-.0133,11.6702-1.0876,14.2401-1.453,2.5698-.3652,9.8399,1.1154,10.5678-1.4136,.2063-.6912,.2253-1.4153,.062-2.1714,0,0-7.601,1.4022-11.1888,1.0472-3.5879-.3549-11.4469,1.5429-15.5023,1.1809-4.0554-.3622-8.5436-1.721-8.5436-1.721l-1.274-.8273c-.2071,.578-.4425,.9706-.1292,1.5514Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9065,396.6738c.0715,.0014,.0562,.6601,.3874,1.3702,.3186,.716,.8257,1.1364,.7799,1.1915-.0256,.0562-.6466-.3124-.9972-1.0925-.3587-.7762-.2292-1.4868-.1701-1.4692Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.4153,394.789c.0725-.0062,.1086,.7854,.58,1.6015,.4575,.8243,1.1176,1.2622,1.0751,1.3212-.0181,.0584-.7877-.3176-1.2829-1.2036-.5049-.88-.4317-1.7336-.3722-1.7191Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.2408,392.943c.064-.0283,.3577,.5392,.8414,1.1486,.4791,.6134,.9617,1.0321,.9191,1.0874-.0342,.0517-.6044-.298-1.1066-.9398-.5058-.6385-.7121-1.2751-.6539-1.2962Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8609,399.4716c.0014,.032-.3708,.0799-.9756,.1128-.6044,.0331-1.4416,.0464-2.365,.0117-.9238-.0354-1.7574-.1123-2.3577-.1913-.6005-.0787-.968-.1548-.964-.1866,.0084-.0687,1.4941,.0717,3.3308,.1393,1.836,.0721,3.3281,.045,3.3315,.1141Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.3603,338.5814c-.5377,.6134,1.6131,9.3549,4.8393,14.1091s5.9147,3.0672,7.1693,8.7415c1.2547,5.6744,1.6131,35.1195,0,37.5733-1.6131,2.4538-3.5846,4.9075-1.9715,5.3676s7.3485,1.687,10.037-1.3802,3.2262-11.8088,3.047-15.7961c-.1792-3.9874,1.0754-24.8444-1.4339-28.3717-2.5092-3.5273-7.1693-6.5945-8.7824-9.9684-1.6131-3.3739-3.2349-16.402-4.1224-17.1764s-8.7824,6.9013-8.7824,6.9013Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M254.4356,380.2546l10.104,8.1299v-7.05s-10.0946-8.2622-10.104-8.0347c-.0093,.2276,0,6.9548,0,6.9548Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.4472 382.1526 254.4315 384.9978 264.3235 392.9296 264.4835 390.3141 254.4472 382.1526"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M260.9702,363.7201c-.0962,.1181-2.3016-1.567-5.1754-3.4081-2.8688-1.8511-5.3168-3.1578-5.2492-3.2944,.0565-.1228,2.6316,.986,5.5308,2.8563,2.9039,1.8608,4.9821,3.7438,4.8938,3.8462Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9184,339.0184c.0179-.0026,.07,.24,.1556,.7038,.0905,.5151,.2089,1.1899,.3566,2.031,.3183,1.7593,.7099,4.3287,1.4166,7.4365,.2174,1.6067,1.5033,2.8489,2.7752,4.2168,1.2994,1.3585,2.798,2.6719,4.3044,4.2048,.6571,.8394,1.4571,1.5566,2.1414,2.4747,.6754,.9033,1.2681,1.9508,1.4714,3.1449,.2727,2.3564,.2118,4.7161,.2369,7.1697-.0113,4.8911-.1188,9.5462-.2348,13.7797-.0428,2.1263-.1774,4.1144-.0949,5.9995,.0264,1.8867-.0392,3.6581-.2901,5.2556-.4689,3.2164-1.8387,5.5969-3.0818,6.8981-.6157,.6644-1.1862,1.0852-1.5875,1.3363-.1951,.1351-.3617,.2098-.4673,.269-.1079,.0557-.1651,.0802-.1695,.0723-.0429-.0567,.8973-.4755,2.0736-1.8132,1.1713-1.3175,2.4542-3.6584,2.8683-6.8169,.4749-3.1357,.0369-6.9857,.2695-11.2127,.0897-4.2317,.1825-8.8855,.1937-13.7682-.0218-2.4264,.0319-4.8532-.2174-7.0747-.1776-1.0849-.7274-2.0784-1.3677-2.9406-.6362-.8669-1.4555-1.6179-2.0989-2.4509-1.4513-1.4953-2.97-2.852-4.2607-4.2282-.6503-.687-1.2648-1.3668-1.7938-2.0826-.259-.3624-.5149-.7187-.6815-1.1416-.1678-.4102-.25-.8151-.3469-1.2072-.6671-3.1479-1.0007-5.7162-1.2585-7.4901-.1077-.8476-.1941-1.5276-.2601-2.0467-.0521-.4689-.0695-.7166-.0518-.7191Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.7935,305.767s.6328,28.1573,4.7463,34.6551c4.1134,6.4979,12.3403,6.4979,16.7702,2.4367,4.4299-4.0611-.8657-25.3371-1.4986-26.1493-.6328-.8123,1.1808-9.3848,1.1808-9.3848,0,0-5.976-5.3424-21.1987-1.5577Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.9609,251.1159s6.2866,9.1663,6.9195,17.83c.6328,8.6638-2.9265,42.5195-3.7175,42.5195-.7911,0-20.014,.3057-20.014,.3057l-5.0627-27.9343-3.7971-30.3232,25.6718-2.3977Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7544,253.8414s-7.2201,28.8132-2.7669,42.4496c3.9323,12.0415,5.7662,16.4734,5.7662,16.4734l22.3952-.9933v-58.8407l-25.3945,.911Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.6576,273.7672c.0356,.0048,.0112,.5447-.0632,1.5133-.0582,.9703-.1188,2.3751-.1275,4.1119,.0008,3.4731,.2612,8.2755,.9582,13.5338,.6727,5.2635,1.6316,9.9766,2.4128,13.3643,.4017,1.6915,.7333,3.0603,.9851,4.0003,.2423,.9427,.3602,1.4697,.3258,1.4803-.0343,.0105-.2178-.4966-.5205-1.424-.3122-.9247-.6991-2.2825-1.1479-3.9685-.8755-3.3762-1.8961-8.099-2.5718-13.3854-.7-5.2808-.9037-10.1148-.8099-13.6061,.0559-1.7463,.1732-3.1563,.2939-4.1256,.137-.9681,.2294-1.4992,.265-1.4943Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7403,281.3793c-.0416,.0479-.7454-.4548-1.7743-1.4024-1.0218-.9496-2.3527-2.3832-3.5029-4.1962-1.1463-1.8148-1.9179-3.5933-2.4424-4.8812-.5165-1.2939-.7812-2.1139-.7174-2.1407,.0687-.029,.4539,.7417,1.0542,1.9918,.6082,1.245,1.4242,2.9768,2.545,4.7506,2.2632,3.545,4.979,5.7368,4.8378,5.8781Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.7283,209.0946c-.7239,.8717,5.8,24.6979,5.5034,31.6714-.2965,6.9736,1.5227,13.0754,1.5227,13.0754,14.7002,1.8139,28.7308,.7405,42.2065-2.7255l6.6822-44.6364s-13.3442-14.5282-12.7511-26.7319l-32.6191,2.3245-10.5446,27.0225Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.499,
    y: 220.4857,
    width: 31.3547,
    height: 18.2425,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.4011,242.7159c-.0147,.0328-.4087-.1086-1.1091-.3927-.7013-.2821-1.7041-.7178-2.9333-1.2782-2.4588-1.1196-5.8113-2.7683-9.4209-4.7629-3.6096-1.9977-6.7884-3.961-9.0439-5.4484-1.1281-.7433-2.0301-1.361-2.6418-1.8049-.6128-.4422-.942-.7007-.922-.7306s.3871,.1716,1.0335,.5613c.7379,.45,1.6495,1.0058,2.7273,1.663,2.3014,1.405,5.5001,3.3121,9.0989,5.3039,3.5989,1.9886,6.9143,3.684,9.3277,4.8863,1.1297,.5636,2.0851,1.0403,2.8586,1.4261,.6737,.3404,1.0396,.5443,1.025,.5771Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.1489,
    y: 203.787,
    width: 9.6019,
    height: 6.3568,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.2492,150.5776c-.4466-.4803-1.8466-9.7732,.546-13.0257s8.433-2.1905,8.433-2.1905l-8.979,15.2162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.8309,181.4623l-.0231-5.1071s-7.7785-1.2735-7.8122-9.0607c-.016-3.761,.5807-11.5083,1.2022-18.5136,.668-7.5319,7.0085-13.2865,14.5696-13.2258l.7514,.006c8.0971,.5382,12.1638,7.7157,11.4017,15.7952l-2.3433,28.8413-10.2478,9.6797-7.4985-8.415Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.8078,176.3552s4.9051,.452,10.171-2.0762c0,0-2.3981,4.8278-10.1621,4.0643l-.0089-1.9881Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.9513,156.3669c-.0256,.5871,.4506,1.0928,1.0632,1.1304,.6114,.0376,1.1288-.4063,1.1542-.9933,.0253-.587-.4505-1.0933-1.0619-1.1312-.6127-.0378-1.1301,.4072-1.1555,.9941Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.841,152.604c.1367,.1461,.9839-.4707,2.1807-.458,1.1954-.0045,2.0686,.6184,2.1994,.4729,.0644-.0643-.0739-.3273-.454-.6086-.3742-.2804-1.0139-.5552-1.7596-.5581-.7451-.0017-1.3744,.2676-1.7371,.5456-.3702,.2794-.4968,.5407-.4294,.6062Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.7942,163.2667c-.1896-.0637-.6429,.881-1.7026,1.4376-1.0502,.5709-2.1144,.4367-2.1605,.6268-.0263,.0872,.2203,.2531,.6883,.3205,.4624,.0693,1.1559,.0078,1.8138-.3433,.6568-.3518,1.0831-.8874,1.2704-1.3042,.1935-.4216,.181-.7117,.0906-.7374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.1677,156.3669c-.0256,.5871,.4505,1.0925,1.0631,1.1304,.6115,.0378,1.1289-.4062,1.1543-.9935,.0254-.5869-.4509-1.0931-1.0624-1.1309-.6124-.0381-1.1297,.407-1.155,.994Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6008,152.9214c.137,.1462,.9855-.4702,2.1814-.4576,1.195-.0044,2.0684,.6183,2.1994,.4728,.0641-.0643-.0728-.3272-.4545-.6086-.3741-.2805-1.0138-.555-1.7592-.558-.7452-.002-1.3745,.2675-1.7374,.5453-.3691,.2795-.4964,.5408-.4297,.6061Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.1872,161.7608c.0062-.0681-.7367-.2027-1.9406-.3664-.3052-.0338-.5939-.097-.6437-.3062-.0702-.2212,.0602-.5494,.2111-.9039,.2931-.7368,.6001-1.5097,.9222-2.3194,1.2816-3.3024,2.2117-6.019,2.0783-6.0696-.1337-.0503-1.2806,2.5856-2.5618,5.8882-.3086,.8144-.6037,1.5907-.8845,2.3336-.1182,.3463-.3203,.7387-.1681,1.1979,.0806,.229,.3035,.3966,.4989,.4507,.1954,.0614,.3672,.0662,.5183,.0763,1.2125,.075,1.9647,.0864,1.9699,.0188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3295,148.2296c.1155,.3264,1.3116,.1817,2.7138,.3623,1.4064,.1522,2.535,.5723,2.7236,.2821,.0842-.139-.1105-.4466-.5659-.7653-.4511-.3181-1.1727-.6229-2.0146-.7234-.842-.0989-1.6148,.0287-2.1278,.2328-.5169,.2033-.7786,.4569-.7291,.6115Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3086,149.1444c.2083,.2736,1.0347-.0021,2.0263-.0073,.9909-.04,1.8291,.1974,2.0244-.0854,.0857-.1373-.044-.4107-.4088-.6709-.3592-.2593-.9623-.4735-1.6434-.4585-.6812,.0162-1.2735,.2577-1.6206,.5333-.3524,.2766-.4697,.5557-.3779,.6888Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.6097,146.405s2.4585-6.049,4.8188-7.168c2.8575-1.3547,4.058,1.7798,6.7768,1.0433,2.7188-.7367,5.4601-.9964,7.7703,1.601,1.7081,1.9205,2.0134,2.4,2.1733,5.8564,.6474,14.0132,3.1736,17.995,3.9541,11.403,.0856-.7223,2.0962-1.281,2.4181-4.3326,.4173-3.957,.1367-8.6702-.7246-11.4876-.7259-2.3748-1.592-4.116-3.9992-5.9398-3.8003-2.8787-9.0644-3.1019-12.6204-2.6519-6.5254,.8258-10.9512,6.834-10.5672,11.6762Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.6085,158.9249c.0587-1.2013,1.102-2.1419,2.2984-2.0184,1.451,.1494,3.0604,.9872,2.9406,3.9872-.2126,5.3221-5.5122,4.0107-5.5151,3.8578-.0022-.1042,.1674-3.6003,.2761-5.8266Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5702,162.7954c.0242-.0162,.0903,.0686,.2441,.1467,.15,.0759,.4107,.1347,.6926,.0419,.5703-.1839,1.0793-1.0575,1.1437-2.0157,.0328-.4837-.0504-.949-.2067-1.3378-.1467-.3959-.3876-.6779-.6688-.7394-.279-.0763-.4861,.085-.5573,.2323-.0774,.1458-.0479,.2534-.0763,.2613-.0154,.0129-.1106-.0938-.059-.3118,.0263-.1047,.0937-.2278,.2227-.3249,.132-.099,.3218-.1443,.5181-.1152,.4092,.0448,.7636,.4373,.9354,.864,.1944,.4293,.2993,.9528,.2623,1.496-.0771,1.0712-.6661,2.0529-1.4444,2.2442-.3783,.083-.6859-.0426-.8423-.1744-.1596-.1383-.1828-.2585-.1641-.2672Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.5137,133.2366c-3.1299-.6906-6.3959-.2581-9.5341,.3942,.3726,.4747,.7453,.9493,1.1179,1.424-1.2391-1.0052-2.9318-1.3075-4.5206-1.1608-1.5886,.1466-3.1081,.6983-4.6069,1.2453,1.3067,2.036,3.2445,3.6608,5.4772,4.5926s4.7505,1.1665,7.117,.6634l12.841-2.6061c-1.1418-2.995-4.7616-3.8621-7.8915-4.5526Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.8795,180.329s8.9212-7.2123,22.8628-3.685c0,0,16.3503-5.1034,22.2015-5.521h.8106s3.0268-10.927,4.1185-16.8278c1.2402-6.7044,1.6258-10.9231,1.2566-10.9304-1.2154-.0241,7.7459,.4885,7.8327,.1295,.1156-.4781,2.2455,28.7022-1.6178,34.6833-3.8633,5.981-20.7316,13.0356-26.827,13.4957-6.0954,.4601-10.7986-.6135-11.4705,0-.6719,.6134-6.4586,15.1141-6.4586,15.1141,0,0-13.3994-11.578-12.7088-26.4584Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3667,198.9873c-.063-.0434,.5242-.9911,1.4557-2.5287,.9317-1.5374,2.1931-3.6748,3.4839-6.0916,1.2899-2.4182,2.3635-4.656,3.1192-6.287,.7568-1.6305,1.2141-2.647,1.2853-2.619,.0626,.0243-.274,1.0901-.9475,2.7655-.6721,1.6754-1.6998,3.9528-2.9976,6.3858-1.2986,2.4314-2.6183,4.5524-3.6333,6.045-1.0151,1.4932-1.7105,2.3684-1.7657,2.33Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M291.44629,145.3996c-.133-.3253-6.4681-5.9525-6.5008-8.4391-.0328-2.4866,.4108-8.4721,1.2604-8.8078,.8495-.3358,1.7348,.1154,1.8656,4.0469s.4533,3.2991,.4533,3.2991c0,0,5.7461,.0036,6.3054,4.2837s-3.3839,5.6172-3.3839,5.6172Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.86509,128.0273c-.125-.4239,.5851-3.0241,2.8012-1.1877l.7775,1.4258s1.9914-3.5524,3.4249-.738c1.4335,2.8143,.8001,1.4646,.8001,1.4646,0,0,2.0955-1.4297,3.17421,1.2572,1.07869,2.687,1.22969,6.2043,1.22219,8.3914-.0069,2.0369-1.5014,7.2325-1.5014,7.2325l-5.7353-.3815s-7.3294-13.2533-6.8703-13.615c.459-.3618,1.9069-3.8493,1.9069-3.8493Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.25839,141.9042c-.0839,.0307-.3897-.899-1.2188-2.2034-.8221-1.2806-2.2677-2.9743-4.4294-3.8651-.2949-.1293-.5994-.2173-.8845-.3087l-.2023-.065,.0119-.1997c.127-2.1236-.3309-4.0004-.8154-5.2664-.4824-1.2756-.9366-1.9876-.868-2.0304,.042-.0314,.6054,.6195,1.1897,1.8975,.5845,1.2654,1.1283,3.2074,1.0103,5.4291l-.1902-.2644c.3056,.0947,.6317,.1888,.9464,.3263,2.3118,.9555,3.7813,2.7883,4.54691,4.1568,.77429,1.3991,.95579,2.3813,.90339,2.3934Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.32939,127.7917c.05961-.0165,.3441,.7303,.4667,2.0087,.0571,.6394,.0722,1.4009-.0309,2.2559-.0596,.4252-.17919,.9275-.5477,1.3259-.32849,.4072-1.0342,.6253-1.5676,.3504-.536-.2354-.8565-.7295-1.0302-1.1725-.1776-.4543-.2745-.8795-.3712-1.2948-.18249-.829-.2626-1.5908-.2827-2.2295-.0389-1.2808,.13021-2.059,.192-2.0517,.081,.0057,.04421,.7872,.1753,2.0259,.06591,.6186,.1811,1.3508,.3824,2.1449,.2184,.7637,.4033,1.7698,1.1454,2.1016,.3546,.1681,.722,.0581,.9842-.223,.2628-.2708,.3802-.6612,.4457-1.0494,.122-.7978,.14721-1.5451,.1376-2.1636-.02539-1.2433-.1786-2.0116-.099-2.0288Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.64709,129.3021c.06691,.0068,.09191,.6396-.00009,1.6655-.10971,1.0062-.31151,2.4987-1.26991,3.8494-.23909,.3184-.508,.6605-.9119,.8528-.1968,.0962-.4463,.1526-.6878,.0953-.2408-.0519-.4378-.2126-.5571-.3741-.2406-.3354-.3206-.6466-.4252-.9363-.0953-.2928-.166-.5707-.2169-.8266-.1976-1.0288-.1108-1.6762-.0483-1.6749,.0805-.0039,.1272,.6285,.4059,1.5869,.1457,.4516,.3405,1.0926,.6605,1.5528,.3118,.4573,.9558,.0407,1.3589-.5812,.8671-1.2129,1.1299-2.6171,1.3272-3.5962,.183-.9943,.2887-1.6213,.3647-1.6134Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.351,131.6553c.05729-.0224,.24579,.3473,.12179,.9634-.1235,.6114-.561,1.3429-1.2357,1.9683-.3445,.3145-.7947,.5443-1.2359,.5669-.4367,.036-.8604-.1445-1.07319-.4146-.21731-.2623-.264-.5489-.23511-.7284,.028-.1831,.1052-.2584,.1345-.247,.0707,.0122-.0086,.3949,.366,.7201,.3417,.3265,1.1225,.2748,1.698-.2865,.5995-.5563,1.0447-1.1902,1.2275-1.6808,.1917-.4944,.1527-.8469,.23211-.8614Z",
    style: {
      fill: "#ff9a6c"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.0145,186.2466c.3359-.1533,16.0886-1.0767,19.784-2.1502,3.6954-1.0735,5.7226-2.3963,13.9532-3.4698s13.7473,1.656,13.7473,1.656l-10.8009,29.0094s-5.0601-10.0589-5.5641-9.9056c-.5039,.1534-28.1923,1.1033-33.2314-.1236-5.0392-1.2268-27.2528-24.8807-26.9168-25.3408l7.9708-5.3922",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M139.9182,170.9278c-.2447-.2524-2.8588-8.3124-5.1235-9.3397-2.2648-1.0273-7.9257-3.0214-8.574-2.3778-.6483,.6435-.59,1.6355,2.959,3.332s2.8404,1.7384,2.8404,1.7384c0,0-2.3012,5.2651,1.3952,7.4941,3.6965,2.2289,6.5029-.847,6.5029-.847Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4405,160.6799c-.3382-.2845-3.0049-.6769-2.2115,2.0897l.9943,1.2841s-4.0528,.3995-2.0496,2.8414,1.0208,1.3203,1.0208,1.3203c0,0-2.1502,1.3462-.1214,3.412,2.0288,2.0657,5.1902,3.6147,7.1968,4.485,1.8687,.8106,7.2275,1.5253,7.2275,1.5253l1.9506-5.4069s-9.2012-12.0294-9.7166-11.754c-.5155,.2754-4.2909,.2031-4.2909,.2031Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1874,173.018c-.0322,.0431-.8592-.517-1.8303-1.7874-.9466-1.2502-2.0361-3.3315-1.9843-5.8324,.0003-.3434,.0449-.6798,.0807-.9978l.1659,.2803c-2.0825-.783-3.6434-2.06-4.5681-3.1028-.9364-1.0478-1.3067-1.8251-1.261-1.8509,.0666-.0457,.5367,.656,1.5118,1.6094,.9654,.9516,2.5009,2.1238,4.4972,2.8591l.1878,.0692-.0217,.2114c-.0306,.2978-.0721,.6121-.0719,.934-.0509,2.3375,.9208,4.341,1.7642,5.6078,.8623,1.2826,1.5914,1.9356,1.5297,2.0001Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.8352,163.759c.0477-.0661,.6901,.3824,1.8189,.9043,.5627,.2568,1.2574,.5335,2.0371,.7417,.3819,.0956,.7866,.1447,1.14,.0125,.3627-.1274,.6109-.4199,.5991-.8121-.0063-.8129-.8539-1.3858-1.4658-1.8921-.6468-.5029-1.2713-.902-1.8116-1.2106-1.0821-.6168-1.8127-.8966-1.7854-.9731,.0181-.0595,.7987,.0977,1.9564,.647,.5771,.2746,1.2428,.6535,1.9289,1.1532,.3417,.2551,.6924,.5144,1.0373,.8593,.3361,.3367,.6602,.8286,.6609,1.4139,.038,.5989-.4449,1.1579-.9497,1.2955-.5127,.1778-1.0208,.0859-1.4343-.03-.8245-.2485-1.516-.5677-2.0789-.8765-1.1219-.625-1.6919-1.1851-1.6529-1.233Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.4872,168.32c.0233-.0729,.6401,.0818,1.6242,.3129,.9761,.212,2.3678,.5343,3.8266,.2265,.7314-.1198,1.3713-.5427,1.0774-1.0118-.2932-.4776-.8022-.9131-1.1575-1.2278-.7661-.6397-1.3268-.9361-1.2909-1.0083,.0239-.0577,.6518,.1225,1.5149,.7161,.214,.1492,.4403,.3254,.6703,.5301,.2234,.212,.4764,.4102,.6871,.765,.1001,.1742,.1683,.4191,.1193,.6604-.0444,.2443-.1961,.4502-.3632,.5919-.3381,.2929-.7593,.402-1.1469,.4933-1.6217,.3363-3.0698-.0775-4.0356-.3806-.9766-.3271-1.5463-.6038-1.5257-.6677Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5584,171.7407c.0452-.067,.3525,.1101,.8822,.1328,.5228,.0292,1.282-.1244,2.032-.4504,.745-.3021,1.1055-.9966,.9435-1.4406-.1477-.4735-.53-.5545-.5129-.6242,.0013-.0313,.1013-.0718,.2802-.024,.176,.0455,.4198,.2032,.573,.5075,.1621,.3033,.1575,.7638-.0507,1.1494-.1976,.3951-.5886,.7154-1.015,.9048-.8435,.3672-1.6889,.4746-2.2986,.3425-.6141-.1334-.8772-.4543-.8337-.4978Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.8435,192.1861c.1377-.0727,1.7835,2.9294,4.1963,6.3778,2.4007,3.4587,4.647,6.0414,4.531,6.1455-.0505,.0456-.6784-.5431-1.6047-1.579-.9265-1.035-2.1392-2.528-3.3536-4.2687-1.2122-1.7413-2.1929-3.3957-2.8432-4.6232-.6512-1.2277-.9861-2.0207-.9258-2.0524Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.3825,209.5779l-.4834-3.0073c-.0518-.3208,.0337-.6509,.2338-.9067,.2002-.2559,.5005-.418,.8238-.4443,1.1601-.0967,3.4634-.2173,4.7329-.2803,.6294-.0386,1.167,.4345,1.2305,1.0605l.5161,3.2788-.9883,.1553-.5195-3.3066c-.0127-.1231-.0996-.1973-.189-.189-1.0171,.0503-3.5112,.1787-4.6997,.2773-.0645,.0054-.1026,.043-.1196,.0645-.0171,.022-.044,.0679-.0337,.1313l.4834,3.0074-.9873,.1591Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.8044,181.9186l11.4942,25.0719,5.0201-.6349s-10.1845-26.4841-10.6165-26.3306c-.4321,.1534-5.8978,1.8936-5.8978,1.8936Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7624,181.2942l10.5464,24.4505s1.5046-.3625,1.5545-.3591c.0498,.0035-9.7251-24.8493-9.7251-24.8493l-2.3758,.7579Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.8922 180.1121 220.2986 206.9905 225.4305 206.5646 239.4822 179.6878 233.8922 180.1121",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M222.4246,198.5685s-3.1209,6.6049-3.1092,6.6263c.0117,.0213,.9832,1.7957,.9832,1.7957h0l3.1255-5.6624-.9995-2.7596Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.34,180.0022s-13.3194,26.6832-13.1196,26.7452l1.6475-.2083,14.3914-26.7915-2.9193,.2546Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M229.3891,215.0735c-.2552,3.3938-3.2133,5.9381-6.6071,5.6828-3.3938-.2552-5.9381-3.2133-5.6828-6.6071,.2552-3.3937,3.2133-5.938,6.6071-5.6828s5.938,3.2133,5.6828,6.6071Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.3891,215.0735c-.2552,3.3938-3.2133,5.9381-6.6071,5.6828-3.3938-.2552-5.9381-3.2133-5.6828-6.6071,.2552-3.3937,3.2133-5.938,6.6071-5.6828s5.938,3.2133,5.6828,6.6071Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.4422,214.3677c-.2552,3.3938-3.2133,5.938-6.6071,5.6828s-5.9381-3.2133-5.6828-6.6071c.2552-3.3938,3.2133-5.9381,6.6071-5.6828,3.3937,.2552,5.938,3.2133,5.6828,6.6071Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M228.3967,214.3599c-.212,2.8193-2.6694,4.933-5.4887,4.7209-2.8193-.212-4.9329-2.6694-4.7209-5.4887s2.6694-4.9329,5.4887-4.7209,4.933,2.6694,4.7209,5.4887Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.6329,209.4419c2.7229,.2048,4.7811,2.5053,4.728,5.2023,.0124-.0947,.0286-.1879,.0358-.2843,.2121-2.8193-1.9016-5.2767-4.7209-5.4887s-5.2767,1.9016-5.4887,4.7209c-.0073,.0964-.0052,.191-.0071,.2864,.3509-2.6745,2.7299-4.6413,5.4529-4.4366Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M223.7834,211.2712l.4647,1.152c.0394,.0977,.1245,.1699,.2274,.1928l1.2124,.2703c.2591,.0578,.3395,.3876,.136,.5582l-.952,.7979c-.0808,.0677-.1231,.1709-.1131,.2758l.1176,1.2367c.0251,.2643-.2638,.4427-.4889,.3018l-1.053-.6588c-.0894-.056-.2006-.0643-.2973-.0224l-1.1398,.494c-.2436,.1056-.5025-.114-.4381-.3716l.3012-1.2052c.0255-.1022-.0009-.2106-.0706-.2896l-.822-.9313c-.1757-.1991-.0469-.5132,.218-.5316l1.2392-.0859c.1052-.0073,.2-.0659,.2537-.1567l.6317-1.0695c.135-.2286,.4736-.2032,.5729,.0431Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.6758,208.8712c1.2087,.0909,2.2858,.5966,3.1075,1.3645l1.274-.2426s-.9123-1.1492-2.0785-1.6369l-2.6999,.5052c.1317-.0002,.2634-.0002,.3969,.0098Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.4553,209.2027l-2.6636,.4984s-1.1208,1.2237-1.361,2.3156l1.2412-.2363c.5641-1.1861,1.5655-2.108,2.7834-2.5777Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.9669,208.3512c-.0385-.0161-.0175-.0073,0,0h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.6724,215.511c-.1322,.0453-.4702-.6307-.5174-1.5427-.0517-.9121,.2115-1.6205,.3477-1.5896,.1451,.0282,.1234,.7236,.1723,1.5614,.0419,.838,.1386,1.5271-.0026,1.5709Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.7451,211.6618c.104,.1003,.1531,.2193,.1303,.2803-.0264,.0596-.1446,.1102-.2892,.1091-.143,.0002-.2577-.1454-.193-.3058,.0659-.1598,.2498-.1837,.3519-.0836Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.9709,212.916s.6798,.9491,.9619,1.0236c.282,.0745,2.2249-.9832,2.2196-1.2462-.0052-.263-.5334-1.5533-.7122-1.5042-.1788,.0491-.7129,1.3345-.8999,1.408s-1.3061-.0241-1.5694,.3188Z",
    style: {
      fill: "#fff"
    }
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Podium--inject-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 445.81719,
    y: 362.8123,
    width: 29.4891,
    height: 72.4617,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 445.81719,
    y: 362.8123,
    width: 29.4891,
    height: 72.4617
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 585.47689,
    y: 434.408,
    width: 29.48911,
    height: 36.3766,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 585.47689,
    y: 434.408,
    width: 29.48911,
    height: 36.3766
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "588.18469 434.4712 449.02209 434.4712 449.02209 362.8123 306.96039 362.8123 306.96039 404.3463 164.1739 404.3463 164.8796 470.8745 588.89039 470.8745 588.18469 434.4712",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.35049,399.3216v31.4066h-8.883v-24.542h-5.8324v-6.8646h14.7154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.94109,458.1195c0,3.8584-3.0479,7.5546-9.8897,7.5546-3.1445,0-6.48439-.7783-8.8193-2.2373l2.33491-4.831c1.81549,1.2314,4.15039,1.8799,6.29009,1.8799,2.1728,0,3.5996-.8428,3.5996-2.3662,0-1.3624-1.0059-2.2051-3.46969-2.2051h-2.69151v-4.0537l4.0538-4.377h-8.94929v-4.9609h16.40629v4.0205l-4.7012,5.0586c3.8262,.8105,5.836,3.2744,5.836,6.5176Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,446.7377v5.7123h-19.8307v-4.512l9.5332-8.9149c2.0378-1.8922,2.3288-3.0562,2.3288-4.1119,0-1.6368-1.0917-2.6197-3.2749-2.6197-1.8555,0-3.5295,.8374-4.5484,2.4742l-5.3486-2.9834c1.9282-3.2018,5.5309-5.3123,10.5521-5.3123,5.8583,0,9.897,3.0199,9.897,7.7501,0,2.4743-.6911,4.7303-4.3297,8.0783l-4.803,4.4393h9.8242Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M335.41929,428.1925c-.1289,2.7751,1.275,5.9123,2.83371,8.212,.76029-.1935,1.14419-1.0272,1.37989-1.7754,1.43611-4.5587,1.1822-9.629-.7021-14.0213-1.7652,2.1452-3.3825,4.8095-3.5115,7.5847Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M325.56739,422.9891c-.1985-.0131,2.1624,14.3814,12.68561,13.4154,0,0-8.52711-13.1397-12.68561-13.4154Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M343.418,440.8853c1.08529,2.5574,3.70919,4.7774,6.11,6.1754,.60149-.5036,.58659-1.4213,.47509-2.1978-.6794-4.731-3.1037-9.1914-6.7039-12.3348-.6624,2.698-.9666,5.7999,.11881,8.3572Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M332.28449,440.4608c-.1847,.0741,8.1761,12.0271,17.24351,6.5999,0,0-13.37571-8.152-17.24351-6.5999Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.29339,449.9753c2.08261,1.8387,5.4075,2.7092,8.17661,2.9344,.32529-.7139-.08411-1.5353-.51981-2.1877-2.6544-3.9747-6.766-6.9524-11.37019-8.2346,.56669,2.7198,1.63069,5.6492,3.71339,7.4879Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M347.06659,454.3965c-.1347,.1466,12.5655,7.3218,18.40341-1.4868,0,0-15.584-1.5823-18.40341,1.4868Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M333.27229,413.3722c-1.3038,2.4532-1.377,5.8894-.952,8.6349,.77,.1503,1.4736-.439,2.0068-1.0145,3.2483-3.506,5.18791-8.1975,5.364-12.9737-2.5134,1.1838-5.115,2.9001-6.4188,5.3533Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M326.59359,404.4543c-.1739-.0969-4.1982,13.9239,5.7267,17.5528,0,0-2.0859-15.5247-5.7267-17.5528Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M337.87669,398.7897c-2.3365,1.5028-4.08,4.4648-5.0512,7.0677,.5983,.5075,1.5002,.3374,2.2466,.0959,4.5475-1.4709,8.53291-4.6156,11.021-8.6963-2.7712-.1958-5.8798,.0298-8.2164,1.5327Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M342.13229,386.5509c-2.0605,1.8635-3.2979,5.07-3.8319,7.7964,.673,.4032,1.5351,.0884,2.2322-.2715,4.247-2.1923,6.457-4.4538,8.595-9.8405-2.7661,.2585-4.9349,.452-6.9953,2.3156Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M335.42609,387.9179c-.1198-.1589-9.477,11.0312-1.8718,18.3683,0,0,4.3794-15.0395,1.8718-18.3683Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M345.66179,387.1873c.0031,.0039-.0512,.0585-.1602,.1611-.1204,.1108-.2821,.2597-.4883,.4496-.4432,.4022-1.0767,.9771-1.8868,1.7123-1.50649,1.6095-3.7632,3.9224-5.77749,7.3384-2.019,3.3811-3.95331,7.7656-4.78751,12.9312-.854,5.1321-.77449,11.0217,1.02151,16.7869,.10819,.3605,.21619,.7199,.32379,1.0783l.16121,.5366,.20779,.5184c.2774,.6898,.5528,1.3751,.8264,2.0554l.2046,.5093c.0773,.1653,.1647,.3256,.2464,.4881,.16581,.3239,.331,.6465,.4956,.9679,.3408,.6359,.6291,1.2956,1.0049,1.8971,1.4256,2.459,3.1876,4.5796,4.9961,6.4548,.4698,.4527,.9338,.8998,1.3917,1.3409,.46751,.4306,.9624,.8179,1.4318,1.2204,.2372,.1983,.4726,.3952,.7063,.5906,.24541,.1807,.4889,.36,.7305,.5378,.486,.3517,.9522,.7155,1.4326,1.0413,.9772,.6275,1.9011,1.2663,2.8501,1.7811,.9248,.5566,1.8505,1.0205,2.7329,1.4659,3.5449,1.7578,6.6256,2.7058,8.7671,3.2377l.7604,.1858,.675,.1274c.4184,.0781,.7713,.1544,1.0613,.1812l.6571,.0872c.148,.0213,.2237,.0347,.22341,.0397,0,0-1.23651-.0162-3.40311-.5103-2.1574-.4997-5.2597-1.421-8.832-3.1625-.8893-.4414-1.8221-.902-2.7547-1.4561-.9565-.5123-1.8887-1.1495-2.87419-1.7764-.48461-.3254-.95521-.6893-1.44571-1.0412-.2438-.178-.4894-.3575-.7371-.5383-.2359-.1958-.4737-.393-.71319-.5917-.47391-.4034-.97341-.7918-1.44571-1.2238-.4626-.443-.93129-.892-1.406-1.3465-1.8279-1.8842-3.6095-4.0195-5.0522-6.4999-.3799-.6067-.6712-1.2702-1.0153-1.9109-.1662-.3237-.3329-.6488-.5003-.975-.0824-.1638-.17049-.3253-.2486-.4918l-.2067-.5131c-.276-.6856-.5541-1.3761-.8339-2.0713l-.2096-.5225-.16269-.5408c-.10851-.3612-.21751-.7235-.32671-1.0869-1.81-5.8115-1.882-11.7499-1.0067-16.9167,.8553-5.2008,2.8233-9.6065,4.87641-12.9927,2.04859-3.4214,4.33949-5.7238,5.87509-7.3128,.8247-.7417,1.4871-1.2938,1.9281-1.6756,.2143-.1807,.3824-.3223,.5074-.4278,.11541-.095,.176-.1417,.1792-.1378Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M426.18309,427.3882c.129,2.7752-1.2749,5.9123-2.8337,8.212-.7603-.1935-1.1442-1.0271-1.3799-1.7754-1.436-4.5586-1.1821-9.6289,.7021-14.0213,1.7653,2.1452,3.3826,4.8095,3.5115,7.5847Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M436.035,422.1849c.19859-.0132-2.16231,14.3814-12.68561,13.4153,0,0,8.5271-13.1397,12.68561-13.4153Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M418.18449,440.0811c-1.0854,2.5574-3.7092,4.7773-6.11,6.1754-.60149-.5037-.5866-1.4213-.4751-2.1979,.6794-4.7309,3.10361-9.1914,6.7039-12.3348,.6623,2.6981,.9666,5.7999-.1188,8.3573Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M429.31789,439.6565c.1847,.0742-8.176,12.0272-17.2434,6.6,0,0,13.3757-8.1521,17.2434-6.6Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M404.30909,449.1711c-2.0827,1.8387-5.4076,2.7091-8.1766,2.9343-.3253-.7139,.0841-1.5353,.5198-2.1877,2.6543-3.9746,6.7659-6.9524,11.3702-8.2345-.5667,2.7197-1.6307,5.6492-3.7134,7.4879Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M414.53589,453.5923c.1346,.1465-12.5655,7.3217-18.4034-1.4869,0,0,15.584-1.5823,18.4034,1.4869Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M428.33019,412.5679c1.30381,2.4532,1.377,5.8894,.9519,8.6349-.77,.1503-1.4736-.4389-2.0068-1.0144-3.2482-3.5061-5.1879-8.1975-5.3639-12.9737,2.5133,1.1837,5.1149,2.9,6.4188,5.3532Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M435.00889,403.65c.1738-.0969,4.19811,13.9239-5.7268,17.5528,0,0,2.086-15.5246,5.7268-17.5528Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M423.72569,397.9854c2.3366,1.5029,4.08,4.4648,5.0512,7.0677-.5982,.5075-1.5001,.3374-2.2465,.096-4.5475-1.4709-8.5329-4.6157-11.0211-8.6964,2.7713-.1957,5.8798,.0298,8.2164,1.5327Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M419.47019,385.7466c2.0604,1.8636,3.29781,5.07,3.8319,7.7964-.673,.4033-1.53509,.0884-2.2322-.2714-4.247-2.1924-6.4571-4.4539-8.5951-9.8405,2.76621,.2584,4.9349,.4519,6.9954,2.3155Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M426.17639,387.1137c.1197-.159,9.4769,11.0311,1.8717,18.3682,0,0-4.3793-15.0395-1.8717-18.3682Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M415.94069,386.383c-.0032,.004,.0511,.0585,.1602,.1611l.4882,.4496c.4433,.4023,1.0767,.9772,1.88691,1.7124,1.50639,1.6094,3.76319,3.9223,5.77739,7.3384,2.019,3.3811,3.9534,7.7655,4.78761,12.9311,.85389,5.1321,.77449,11.0217-1.02151,16.7869-.1083,.3605-.2162,.7199-.3239,1.0783l-.1611,.5366-.2079,.5184c-.2774,.6898-.5528,1.3751-.8263,2.0554l-.2046,.5094c-.0774,.1652-.1648,.3255-.2464,.488-.1659,.3239-.3311,.6466-.4956,.9679-.3408,.6359-.6292,1.2956-1.0049,1.8972-1.4257,2.459-3.1876,4.5796-4.9961,6.4547-.4699,.4527-.9339,.8998-1.3918,1.341-.4675,.4305-.9624,.8179-1.4317,1.2203-.23719,.1983-.4727,.3952-.7064,.5907-.2454,.1806-.4889,.3599-.7305,.5378-.486,.3516-.9522,.7154-1.4326,1.0413-.9772,.6275-1.9011,1.2663-2.8501,1.781-.9247,.5567-1.8505,1.0206-2.7328,1.466-3.545,1.7577-6.6256,2.7057-8.7672,3.2376-.2681,.0655-.5217,.1275-.7603,.1859l-.6751,.1273c-.4183,.0782-.77119,.1544-1.0613,.1812-.2775,.0368-.4951,.0657-.657,.0872-.148,.0213-.2238,.0347-.2234,.0397,0,0,1.23651-.0162,3.4031-.5103,2.15741-.4996,5.2596-1.4209,8.832-3.1625,.8892-.4414,1.8221-.9019,2.7546-1.4561,.9566-.5123,1.8887-1.1495,2.8743-1.7763,.4846-.3255,.9552-.6894,1.4456-1.0412,.2438-.1781,.4895-.3576,.7371-.5384,.236-.1957,.4737-.393,.7133-.5917,.4739-.4033,.9733-.7918,1.4456-1.2238,.4626-.443,.9314-.8919,1.4061-1.3465,1.82781-1.8841,3.6094-4.0195,5.0521-6.4999,.3799-.6067,.6713-1.2701,1.0154-1.9109,.1661-.3237,.3329-.6487,.50031-.975,.08229-.1637,.17039-.3252,.24859-.4917l.2067-.5132c.276-.6855,.554-1.3761,.8339-2.0713l.2096-.5224,.1626-.5409c.1085-.3612,.2175-.7234,.3267-1.0868,1.81-5.8116,1.8821-11.75,1.0068-16.9168-.8553-5.2007-2.8233-9.6065-4.8764-12.9927-2.0487-3.4214-4.3396-5.7237-5.8752-7.3127-.8246-.7418-1.487-1.2938-1.9281-1.6757-.2143-.1807-.3824-.3223-.5074-.4277-.1153-.0951-.176-.1418-.1791-.1379Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.87269,471.161c-.1439,0-.2605-15.2431-.2605-34.042,0-18.8055,.1166-34.0453,.2605-34.0453,.1437,0,.26031,15.2398,.26031,34.0453,0,18.7989-.11661,34.042-.26031,34.042Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 300.449,
    y: 404.3463,
    width: 6.42359,
    height: 66.5282
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 449.11359,
    y: 434.5102,
    width: 6.4236,
    height: 36.3643
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M449.05659,469.3532c-.1439,0-.2605-23.7855-.2605-53.1196,0-29.3443,.1166-53.1247,.2605-53.1247,.1437,0,.2603,23.7804,.2603,53.1247,0,29.3341-.1166,53.1196-.2603,53.1196Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.966,434.4197c0,.1439-37.19261,.2605-83.06141,.2605-45.8848,0-83.0695-.1166-83.0695-.2605,0-.1437,37.1847-.2604,83.0695-.2604,45.8688,0,83.06141,.1167,83.06141,.2604Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParalympicwinnerspodiumPana);
export default __webpack_public_path__ + "static/media/paralympic winners podium-pana.73d092d64ba2c21c6895aa2e7717a918.svg";
export { ForwardRef as ReactComponent };